/* eslint-disable no-console,no-undef, camelcase, no-constant-condition */
import React, { Component } from "react";
import moment from "moment";
import PropTypes from "prop-types";
import _ from "lodash";
// import Datetime from "react-datetime";
import { connect } from "react-redux";
import { toast } from "react-toastify";
import Waiting from "../Waiting";
import {
  // getOrientation,
  // resetOrientation,
  // checkImage,
  getPermissionStatus,
  fetchApi,
} from "../../utils/methods";
import { recurringTypes, eventsTierPoints, wellnessChallengePoints } from "../../../mockData";
import { getAllCompanies } from "../../redux/actions/challengeActions";
import {
  getUserCompanyDetails,
  allowChallengeEventForSpouseDependent,
} from "../../redux/actions/userProfileActions";
// import {imageErrorMessage } from "../../utils/constants";
import timezones from "../../../timezones.json";
import { withTranslation } from "react-i18next";
import {
  Layout,
  // ChallengeHeading,
  Container,
  InputContainer,
  RadioContainer,
  StyledInputV2,
  StyledLabel,
  // RemoveImage,
  ButtonContainer,
  StyledLabelV2,
  // StyledDateTime,
  Locationwrapper,
  Heading,
  // InputContainerV2,
  // FlayerMain,
  EditorContainer,
  SearchDropDown,
  // CircleNew,
  // MUICalendarWrapper,
  // UploadPhotoContainerV1,
  // RemoveImageV3,
  // InputImageV1,
  CustomRadioButtonNew,
  CustomCheckBoxButton,
  CustomRadioButton,
  AllCompaniesContainer,
  ReminderTemplate,
} from "./style";
import RadioButtonNew from "../ContentV2/CustomRadioButtonNew";
import { TitleContainer } from "../AdminTeamCreation/styles";
import { Main } from "../AdminTeamCreation/styles";
import { getCompanyDepartment, getCompanyLocation } from "../../redux/actions";
// import { DateIconContainer } from "./styles";
// import { StyledSvg } from "../MainEvents/styles";
import Editor from "../CKEditor";
import Select from "react-select";
// import HoverButton from "../common/HoverButton";
import CommonDropdown from "../common/CommonDropDown/CommonDropdown";
import {  /*EventsCalendarIcon,PromotionalDocIcon*/ DropIcon, RecognitionCloseIcon, RecognitionTickIcon, UploadHDMIcon, closeIcon, CalendarBranding,/* AdminLeftArrowIcon, AdminRightArrowIcon*/ } from "../../utils/icons";
// import CircularProgressBar from "./circularProgressBar";
import { CreateEventAPI, GetCompanyInfo, GetTeams } from "../../redux/constants/apiConstants";
import { http } from "../../redux/http";
import { Border } from "../Journeys/styles";
import { SearchFilter1 } from "../PeopleHomeV2/styles";
// import { DemoContainer } from '@mui/x-date-pickers/internals/demo';
// import { DateTimePicker } from '@mui/x-date-pickers/DateTimePicker';
// import { renderTimeViewClock } from '@mui/x-date-pickers/timeViewRenderers';
// import { LocalizationProvider, TimePicker } from "@mui/x-date-pickers";
// import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import dayjs from 'dayjs';
import { withRouter } from 'react-router-dom';
import { FetchCoaches } from '../../redux/constants/apiConstants';
import { BASE_URL } from "../../utils/config";
import { NewActivityDropdownCommon } from '../common/CommonDropDown/style';
import { Dropdown } from "react-bootstrap";
import { DateCard, FormHeading } from "../ChallengeCreationAdmin/ActivityChallengeLaunch/style";
import { ManagerIconContainer } from "../Manager/styles";
import StepsHeading from "../../components/RecogntionAdmin/corevalues/stepNames";
import { CommonButtonPopup } from "../ReportsV2/styles";
import { CommonButtonBorder } from "../common/commonStyles";
import { DateCalendarWrapper } from "../ChallengeDetailsV2/StartChallengePopUp/styles";
import CustomDateTimePicker from "../common/DateRangePicker/CustomDateTimePicker";
import CommonImageUploader from "../common/CommonImageUploader/CommonImageUploader";
import { ImageUrl } from "../../utils/constants";
import parse from 'react-html-parser';

class CreateEvent extends Component {
  constructor(props) {
    super(props);
    this.state = {
      imgSrc: "",
      title: "",
      date: dayjs(),
      endDate: null,
      location: "",
      description: "",
      imageName: "",
      time: dayjs().format("hh:mm a"),
      endTime: dayjs().format("hh:mm a"),
      showDateTimeInput: "",
      selectedMenu: "Select an option",
      showPlaces: true,
      amigosToInvite: [],
      openDateTimePicker: "",
      companies: [],
      city_location: [],
      departments:[],
      teams:[],
      eventPointValue: null,
      eventThemePointValue:null,
      participantingPointValue:null,
      limitUser: "",
      addLimitCheckbox: false,
      allDayEvent: 0,
      eventPoints: [],
      isSpouse: false,
      isDependent: false,
      isEmployee: false,
      selectedOption: 0,
      eventLink: "",
      emailOption: {
        launch_event_email: 0,
        event_reminder_email: 0,
        event_complete_email: 0,
      },
      eventPointKey: "Tier 1: 0 points",
      time_zone: null,
      companiesPermission: false,
      locationPermission: false,
      recurringEvent: recurringTypes[0],
      eventLimitValue: null,
      buttonStatus: false,
      step: 1,
      selectCategory: "",
      so: false,
      radio: null,
      selectLocation: 0,
      selectFlayer: 1,
      selectedCompanyValue: "",
      selectedCompanyCheckBox: this.props.history?.location?.state?.isCustomizedEvent ? 1 : 0,
      dropdown: false,
      isCelebrationEvent: this.props.history.location?.state,
      flayerName: "",
      flayerValue: "",
      showBack: false,
      buttonClickScrollTop: false,
      timeout: false,
      progress: 0,
      menuIsOpen: false,
      iseventUrl: false,
      iseventUrlMsg: "",
      usersToInvite:0,
      allTeams:[],
      filteredCompanies:[],
      searchTerm: '',
      defaultTz:"",
      launch:null,
      getCoachData: [],
      so3: false,
      coachName: '',
      coachId: null,
      companyInfo:null,
      showFrequency: true,
      charCount:0,
      showDatePopupModal: false,
      isCustomizedEvent:false,
      emailerTemplatesData:  [],
      activeTemplateIndex:null,
      loading:false
    
    };
  }


 
  componentDidMount() {
    // this.setEmailerTemplateData()

    const isCelebrationEvent = this.props.history.location?.state;

    window.console.log("isCelebrationEvent",isCelebrationEvent)


    if(this.props.history?.location?.state?.isCustomizedEvent){
      this.setState({isCustomizedEvent:true,eventId:this.props.history?.location?.state?.eventId,title:this.props.history?.location?.state?.title,description:this.props.history?.location?.state?.description,imgSrc:ImageUrl + "/" +this.props.history?.location?.state?.image});
    }

    // const date = new Date("2024-06-12T17:21:22.428Z");
    const timezoneName = Intl.DateTimeFormat().resolvedOptions().timeZone;
    this.setState({time_zone:timezoneName === "Asia/Calcutta" ? "Asia/Kolkata" : timezoneName,defaultTz:timezoneName === "Asia/Calcutta" ? "Asia/Kolkata" : timezoneName })
    this.fetchCoachData();
    const companiesPermission = getPermissionStatus(
      "Show companies in event",
      this.props.userPermissions
    );
    const locationPermission = getPermissionStatus(
      "Show locations in event",
      this.props.userPermissions
    );
    if (companiesPermission||this.props.isAccountManager) {
      if (!this.props.allCompanies) {
        this.props.fetchAllCompanies();
      }else{
        this.setState({filteredCompanies:this.props.allCompanies})
        
      }
    } else {
      this.props.fetchCompanyForUser();
      this.props.allowChallengeEventForSpouseDependent();
      this.setState({
        companies: this.props.userCompany && [this.props.userCompany.id],
      });
    }
    document.addEventListener("mousedown", this.handleClick);
    if (this.props.role === "WELLNESS_CHAMPION") {
      let arr = eventsTierPoints;
      arr.splice(3);
      this.setState({ eventPoints: arr });
    } else {
      this.setState({ eventPoints: eventsTierPoints });
    }
    this.setState({
      companiesPermission: companiesPermission,
      locationPermission: locationPermission
    });
    const{getCompanyDepartment}=this.props;
    getCompanyDepartment(this.props.companyDetails.id);
    this.getTeams(this.props.companyDetails.id);
    this.getCompanyInfo(this.props.companyDetails.id);
  }

  getCompanyInfo = async(companyId)=>{
    let apiUrl = GetCompanyInfo + "/" + companyId;
    try {
      const res = await fetchApi(apiUrl , "GET");
      if (res.status === "success") {
        this.setState({companyInfo: res?.data?.companyInfo?.[0]})

      } else {
        toast.error(res.error);
      }
    } catch (error) {
      window.console.error(error);
    }

  }

  componentDidUpdate(prevProps) {
    this.state.flayerName &&
      this.state.progress < 100 &&
      setTimeout(this.progress, 1000);
    if (this.state.buttonClickScrollTop) {
      window.scrollTo(0, 0);
      window.setTimeout(() => {
        this.setState({ buttonClickScrollTop: false });
      }, 2000);
    }
    if (
      !this.state.companiesPermission &&
      this.props.userCompany !== prevProps.userCompany
    ) {
      this.setState({
        companies: this.props.userCompany && [this.props.userCompany.id],
      });
    }
    if(prevProps.allCompanies != this.props.allCompanies){
      this.setState({filteredCompanies:this.props.allCompanies})
    }
    
  }

  componentWillUnmount() {
    document.removeEventListener("mousedown", this.handleClick);
  }

  fetchCoachData = async () => {
    const AuthToken = localStorage.getItem("AUTH_TOKEN");
    let url = BASE_URL + FetchCoaches;
    await fetch(url, { method: "GET", headers: { AUTHTOKEN: AuthToken },credentials:'include',
      withCredentials: true })
      .then((res) => {
        res
          .json()
          .then((data) => {
            if(data.status === 'success'){
              let coaches = data.data;
              coaches.unshift({id:0,name:"None"}); 
              this.setState({getCoachData: coaches });
            }
          })
          .catch((error) => {
            toast.error(error.message);
          });
      })
      .catch((error) => {
        toast.error(error.message);
      });
  };

  handleSearch = (e) => {
    const value = e.target.value.toLowerCase();
    this.setState({ searchTerm: value });

    const filtered = this.props.allCompanies.filter((company) =>
      company.company_name.toLowerCase().includes(value)
    );

    this.setState({ filteredCompanies: filtered });
  };


  progress = () => {
    this.setState({ progress: this.state.progress < 100 && this.state.progress + 20 });
  };

  changeLimitCheckBox = (value) => {
    this.setState({
      addLimitCheckbox: value,
    });
  };

  eventButtonStatusHover = () => {
    this.setState({
      showBack: true,
    });
  };

  eventButtonStatus = () => {
    this.setState({
      showBack: false,
    });
  };

  onSelectCategory = (name, value) => {
    this.setState({
      [name]: value
    });
    if(name !== 'time_zone')
    {
      this.setState({
        eventLimitValue: name,
      });
    }
  };

  // onChangeDescription = (evt) => {
  //   const newContent = evt.editor.getData();
  //   const trimmedString = newContent.replace(/\s|&nbsp;/g, '');
  //   this.setState({
  //     description: trimmedString
  //   });
  // };

  onSelectLocation = (name, /*value, id*/) => {
    this.setState({
      [name]: name.company_name,
      companies: [name.id],
      isEmployee:false,
      isDependent:false,
      isSpouse:false,
      selectedCompanyValue: name.company_name,
    });
    
    this.props.getCompanyLocation(name.id);
    this.props.getCompanyDepartment(name.id);
    this.getTeams(name.id);
    this.getCompanyInfo(name.id);
  };

  getTeams = async(companyId)=>{
    const AuthToken = localStorage.getItem('AUTH_TOKEN');
    try {
      const res = await http.get(`${GetTeams}/${companyId}`, {headers: {AUTHTOKEN: AuthToken}});
      if (res.message) {
        toast.error(res.message);
      }else{
        this.setState({
          allTeams:res
        })
      }
    }catch(error){
      toast.error(error.message);
    }
  }

  onChangeLocation = (id) => {
    const { city_location } = this.state;
    if (city_location.includes(id)) {
      let index = city_location.findIndex((item) => item === id);
      if (index > -1) {
        city_location.splice(index, 1);
      }
    } else {
      city_location.push(id);
    }
    this.setState({
      city_location: city_location,
    });
  };

  onChangeDepartment = (id) => {
    const { departments } = this.state;
    if (departments.includes(id)) {
      let index = departments.findIndex((item) => item === id);
      if (index > -1) {
        departments.splice(index, 1);
      }
    } else {
      departments.push(id);
    }
    this.setState({
      departments: departments,
    });
  };

  onChangeTeam = (id) => {
    const { teams } = this.state;
    if (teams.includes(id)) {
      let index = teams.findIndex((item) => item === id);
      if (index > -1) {
        teams.splice(index, 1);
      }
    } else {
      teams.push(id);
    }
    this.setState({
      teams: teams,
    });
  };

  selectAllDepartment = (e, locationDetails) => {
    e.preventDefault();
    const { departments } = this.state;
    if (departments.length == locationDetails?.length) {
      this.setState({
        departments: [],
      });
    } else {
      let arr = [];
      for (let i = 0; i < locationDetails?.length; i++) {
        arr.push(locationDetails[i].id);
      }
      this.setState({
        departments: arr,
      });
    }
  };

  selectAllTeam = (e, teamDetails)=>{
    e.preventDefault();
    const { teams } = this.state;
    if (teams.length == teamDetails.length) {
      this.setState({
        teams: [],
      });
    } else {
      let arr = [];
      for (let i = 0; i < teamDetails.length; i++) {
        arr.push(teamDetails[i].id);
      }
      this.setState({
        teams: arr,
      });
    }

  }

  selectAllLocation = (e, locationDetails) => {
    e.preventDefault();
    const { city_location } = this.state;
    if (city_location.length == locationDetails?.length) {
      this.setState({
        city_location: [],
      });
    } else {
      let arr = [];
      for (let i = 0; i < locationDetails?.length; i++) {
        arr.push(locationDetails[i].id);
      }
      this.setState({
        city_location: arr,
      });
    }
  };

  handleClick = (e) => {
    if (
      typeof this.datePickerWrapper === "undefined" &&
      this.datePickerWrapper === null
    ) {
      return;
    }
    if (
      !_.isNull(this.datePickerWrapper) &&
      !_.isUndefined(this.datePickerWrapper) &&
      this.datePickerWrapper &&
      !this.datePickerWrapper.contains(e.target)
    ) {
      this.setState({
        openDateTimePicker: "",
      });
    }
  };

  setDatePickerWrapper = (node) => {
    this.datePickerWrapper = node;
  };

  onChange = (baseImage, imageName) => {
    this.setState({
      imgSrc: baseImage,
      imageName: imageName,
    });
  }

  removePhoto = () => {
    this.setState({
      imgSrc: "",
      imageName: "",
    });
  };


  // onChange = (e) => {
  //   let file = e.target.files[0];
  //   let fileArr = e.target.files;
  //   if (e.target.files[0]) {
  //     if (checkImage(fileArr)) {
  //       if (file?.size / 1000000 <= 20) {
  //         let reader = new FileReader();
  //         reader.readAsDataURL(file);
  //         const array = document
  //           .getElementById("event-upload-file")
  //           .value.split("\\");
  //         reader.onloadend = () => {
  //           this.setState({
  //             imgSrc: reader.result,
  //             imageName: array[array.length - 1],
  //           });
  //           getOrientation(file, (or) => {
  //             resetOrientation([reader.result], or, (baseImage) => {
  //               this.setState({
  //                 imgSrc: baseImage,
  //               });
  //             });
  //           });
  //         };
  //       } else {
  //         toast.error("Please select image file less than 20MB");
  //         document.getElementById("event-upload-file").value = "";
  //       }
  //     } else {
  //       toast.error(imageErrorMessage);
  //       document.getElementById("event-upload-file").value = "";
  //     }
  //   }
  // };

  // uploadPDFFile = (e) => {
  //   let file = e.target.files[0];
  //   if (file) {
  //     let fileArr = file.name.split(".");
  //     if (
  //       fileArr[fileArr.length - 1].toUpperCase() == "PNG" ||
  //       "PDF" ||
  //       "JPEG" ||
  //       "JPG"
  //     ) {
  //       if (file?.size / 1000000 <= 10) {
  //         let reader = new FileReader();
  //         reader.readAsDataURL(file);
  //         reader.onloadend = () => {
  //           this.setState({
  //             flayerValue: reader.result,
  //             flayerName: file.name,
  //           });
  //         };
  //       } else {
  //         toast.error("Please select PDF file less than 10MB");
  //         document.getElementById("event-upload-file").value = "";
  //       }
  //     } else {
  //       toast.error("Please select PDF file");
  //       document.getElementById("event-upload-file").value = "";
  //     }
  //   } else {
  //     // this.changeLoader(false);
  //     this.setState({
  //       flayerValue: "",
  //       flayerName: "",
  //     });
  //     document.getElementById("event-upload-file").value = "";
  //   }
  //   if (this.state.flayerValue) {
  //     this.setState({
  //       timeout: true,
  //     });
  //   }
  // };




  uploadPDFFile = (baseImage,imageName) => {
    this.setState({
      flayerValue: baseImage,
      flayerName: imageName,
    });
  };

  onChangeInput = (e) => {
    if (e.target.value.charAt(0) !== " ") {
      this.setState({
        [e.target.name]: e.target.value,
      },()=>{
        if(e.target.name === "eventLink" || e.target.name === "title"){
          this.setEmailerTemplateData();
        }
      });

      if (e.target.name === "eventLink") {
        this.isUrl(e.target.value);
      }
    }
  };

  // onChangeTimeZone = (name, value) => {
  //   if (name === "recurringEvent") {
  //     const { emailOption,date } = this.state;
  //     if (value !== recurringTypes[0]) {
  //       emailOption["launch_event_email"] = 0;
  //       this.setState({
  //         endDate: null,
  //       });
  //     }
  //     if (value !== recurringTypes[1]) {
  //       this.setState({
  //         eventLimitValue: 2,
  //         endDate: date ? dayjs(date).add(1, 'day') : dayjs(date).add(1, 'day'),
  //       });
  //     }
  //     this.setState({
  //       [name]: value,
  //       emailOption: emailOption,
  //       date: date ? dayjs(date) : dayjs(),
  //     });
  //   } else {
  //     this.setState({
  //       [name]: value,
  //     });
  //   }
  // };
  

  changeDateTimeView = (value) => {
    if (value === "date") {
      this.setState({
        date: dayjs(),
        endDate: dayjs().add(1, 'day'),
        showDateTimeInput: value,
        allDayEvent: 1,
        showFrequency: false
      });
    } else {
      this.setState({
        date: dayjs(),
        endDate:  dayjs().add(1, 'day'),
        showDateTimeInput: "",
        allDayEvent: 0,
        showFrequency: true
      });
    }
  };

  onSelect = (value) => {
    this.setState({
      selectedMenu: value,
    });
  };

  onSelectPoints = (name, /*value, key*/) => {
    this.setState({
      [name]: name.value,
      eventPointKey: name.key,
      eventPointValue: name.value,
    });
  };

  onSelectPointsThemeEvent = (name, /*value, key*/) => {
    this.setState({
      [name]: name.value,
      eventPointKey: name.key,
      eventThemePointValue: name.value,
    });
  };

  onSelectPointsParticipation = (name, /*value, key*/) => {
    this.setState({
      [name]: name.value,
      eventPointKey: name.key,
      participantingPointValue: name.value,
    });
  };

  changeDate = (e, stateName) => {
    console.log("e",e)
    const { showDateTimeInput } = this.state;
    if (showDateTimeInput === "date") {
      this.setState({
        date: moment(e._d).format("MM/DD/YYYY"),
        time: moment(e._d).format("hh:mm a"),
        endDate: moment(e._d).format("MM/DD/YYYY"),
        openDateTimePicker: "",
      });
    } else if (stateName.includes("ate")) {
      this.setState({
        openDateTimePicker: "",
        [stateName]: moment(e._d).format("MM/DD/YYYY"),
      });
    } else {
      this.setState({
        [stateName]: e,
        openDateTimePicker: stateName,
      });
    }
  };

  onChangeDate = (e, stateName) => {
    console.log("e",e)
    const { showDateTimeInput } = this.state;
    if (showDateTimeInput === "date") {
      this.setState({
        date: dayjs(e),
        time: dayjs(e).format("hh:mm a"),
        endDate: dayjs(e).add(1, 'day'),
        openDateTimePicker: "",
      });
    } else if (stateName.includes("ate")) {
      this.setState({
        openDateTimePicker: "",
        [stateName]: dayjs(e),
      });
    } else {
      this.setState({
        [stateName]: e,
        openDateTimePicker: stateName,
      });
    }
  };

  showDatePicker = (value) => {
    if (this.state.openDateTimePicker === value) {

      // this.setState({
      //   openDateTimePicker: "",
      // });
    } else {
      this.setState({
        openDateTimePicker: value,
      });
    }
  };

  onCheckboxChange = (element, value) => {
    const { companies } = this.state;
    if (companies.includes(element)) {
      let index = companies.findIndex((item) => item === element);
      if (index > -1) {
        companies.splice(index, 1);
      }
    } else {
      companies.push(element);
    }
    this.setState({
      companies: companies,
      selectedCompanyValue: value,
    });
  };

  onCompanyCheckboxChange = (element) => {
    const { companies } = this.state;
    if (companies.includes(element)) {
      let index = companies.findIndex((item) => item === element);
      if (index > -1) {
        companies.splice(index, 1);
      }
    } else {
      companies.push(element);
    }
    this.setState({
      companies: companies,
    });
  };

  onChangeEmail = (key) => {
    const { emailOption } = this.state;
    emailOption[key] = emailOption[key] === 0 ? 1 : 0;
    this.setState({ emailOption: emailOption });
  };

  selectAllCompanies = (e,enabledCompanies) => {
    e.preventDefault();
    let invitedCompanies = [];
    // const { allCompanies } = this.props;
    if (this.state.companies.length === enabledCompanies.length) {
      invitedCompanies = [];
    } else {
      enabledCompanies.map((company) => {
        invitedCompanies.push(company.id);
      });
    }
    this.setState({
      companies: invitedCompanies,
    });
  };

  onLocationChange = (e) => {
    const { getPlacesAction } = this.props;
    if (e.target.value.charAt(0) !== " ") {
      this.setState(
        {
          location: e.target.value,
          showPlaces: true,
        },
        () => {
          if (
            this.state.location.length > 3 &&
            this.state.location.trim() != ""
          )
            getPlacesAction(this.state.location.trim());
          this.setEmailerTemplateData();
        }
      );
    }
  };

  setLocation = (location) => {
    this.setState({
      location: location,
      showPlaces: false,
    });
  };

  renderPlaces = (places) =>
    places.map((place, index) => (
      <div key={index} onClick={() => this.setLocation(place.description)}>
        <span>{this.props.t(place.description)}</span>
      </div>
    ));

  selectSpouseDependent = (stateName) => {
    this.setState((prev) => ({
      [stateName]: !prev[stateName],
    }));
  };

  callBackForButtonstatus = () => {
    this.setState({
      buttonStatus: false,
    });
  };

  saveEvent = () => {
    // e.preventDefault();
    const {
      city_location,
      title,
      date,
      description,
      imgSrc,
      // time,
      endDate,
      // endTime,
      location,
      eventLink,
      companies,
      eventPointValue,
      addLimitCheckbox,
      limitUser,
      allDayEvent,
      selectedOption,
      time_zone,
      emailOption,
      locationPermission,
      recurringEvent,
      eventLimitValue,
      flayerValue,
      selectedCompanyCheckBox,
      usersToInvite,
      departments,
      teams,
      coachId,
      isCustomizedEvent,
      emailerTemplatesData,
      eventThemePointValue,
      participantingPointValue,
      isCelebrationEvent

    } = this.state;
    const { /*createEvent,*/ companyDetails, role, isAccountManager } = this.props;
    this.setState({
      buttonStatus: true,
      loading:true
    });
    let isRecurringEvent = recurringEvent === recurringTypes[0] ? 0 : 1;
    let EventDetails = {
      title,
      companies: companies,
      body: description,
      image:imgSrc,
      end_date:dayjs(isRecurringEvent ? date : endDate).format("YYYY-MM-DD") + " " + dayjs(endDate, "hh:mm a").format("HH:mm:ss"),
      start_date:dayjs(date).format("YYYY-MM-DD") + " " + dayjs(date, "hh:mm a").format("HH:mm:ss"),
      event_location: (isCustomizedEvent || isCelebrationEvent)  ? null : !selectedOption ? location : null,
      event_link:  (isCustomizedEvent || isCelebrationEvent)  ? null : selectedOption ? eventLink : null,
      // event_points: eventPointValue,
      event_points: (isCustomizedEvent || isCelebrationEvent) ? eventThemePointValue : eventPointValue,
      all_day_event: allDayEvent,
      time_zone: time_zone,
      ...emailOption,
      is_recurring_event: isRecurringEvent,
      recurring_type: isRecurringEvent ? recurringEvent : null,
      recurring_event_limit: isRecurringEvent ? eventLimitValue : 0,
      event_flyer: flayerValue,
      company_city_states: city_location,
      coach:  (isCustomizedEvent || isCelebrationEvent) ? null : coachId === 0 ||  !coachId ? null : coachId,
      event_for_spouse: this.state.isSpouse ? 1 : 0,
      event_for_dependent:this.state.isDependent ? 1 : 0,
      template_id:isCustomizedEvent ? this.props.history?.location?.state?.eventId : null,
      event_reminder_templates:emailerTemplatesData,
      moment_points: (isCustomizedEvent || isCelebrationEvent) ? participantingPointValue : null ,
      event_type:  (isCustomizedEvent || isCelebrationEvent) ?  "theme" : null,
    };
    if ((role==="ADMIN"||isAccountManager) && selectedCompanyCheckBox===1 && this.props.locationDetails && this.props.locationDetails?.length>0) {
      // EventDetails.company_city_states = city_location;
      EventDetails.event_for_spouse = this.state.isSpouse ? 1 : 0;
      EventDetails.event_for_dependent = this.state.isDependent ? 1 : 0;
      if (this.props.locationDetails && this.props.locationDetails?.length > 0) {
        if(city_location.length > 0){
          (EventDetails.is_for_employee = 1)
        }else{
          (EventDetails.is_for_employee = 0)
        }  
      } else {
        if (companyDetails["spouse_or_dependent"]) {
          EventDetails.is_for_employee = this.state.isEmployee ? 1 : 0;
        } else {
          EventDetails.is_for_employee = 1;
        }
      }
    }
    if (locationPermission) {
      // EventDetails.company_city_states = city_location;
      EventDetails.event_for_spouse = this.state.isSpouse ? 1 : 0;
      EventDetails.event_for_dependent = this.state.isDependent ? 1 : 0;
      if (this.props.locationDetails && this.props.locationDetails?.length > 0) {
        // city_location.length > 0
        //   ? (EventDetails.is_for_employee = 1)
        //   : (EventDetails.is_for_employee = 0);
        if(city_location.length > 0){
          (EventDetails.is_for_employee = 1)
        }
        else{
          (EventDetails.is_for_employee = 0)
        }
      } else {
        if (companyDetails["spouse_or_dependent"]) {
          EventDetails.is_for_employee = this.state.isEmployee ? 1 : 0;
        } else {
          EventDetails.is_for_employee = 1;
        }
      }
    }
    if (addLimitCheckbox) {
      EventDetails.user_limit = parseInt(limitUser,10);
    }


    if(usersToInvite === 0){
      EventDetails.company_departments = null;
      EventDetails.company_city_states = null;
      EventDetails.teams = null;
      EventDetails.is_for_employee = 1;
    }else if(usersToInvite === 1){
      EventDetails.company_departments = departments;
      EventDetails.company_city_states = null;
      EventDetails.teams = null;
      EventDetails.is_for_employee = 0;
    }else if(usersToInvite === 2){
      EventDetails.company_departments = null;
      EventDetails.company_city_states = city_location;
      EventDetails.teams = null;
      EventDetails.is_for_employee = 0;
    }else if(usersToInvite === 3){
      EventDetails.teams = teams;
      EventDetails.is_team_event=1;
      EventDetails.company_departments = null;
      EventDetails.company_city_states = null;
      EventDetails.is_for_employee = 0;
    }

    if(isCustomizedEvent){
      EventDetails.image = null;
      EventDetails.image_url = this.props.history?.location?.state?.image;
    }
    // createEvent(EventDetails, this.failedFunction);
    this.PostEvent(EventDetails)
  };

  PostEvent = async(payload)=>{
    try{
      const res = await fetchApi(CreateEventAPI, "POST",payload);
      if(res.data.message){
        toast.error(res.data.message);
        this.setState({
          buttonStatus: false,
          loading:false
        });
      }else{
        toast.success(res.data[0]);
        this.props.history.push({pathname:"/company/events",state:"updateData"});
        this.setState({
          buttonStatus: false,
          loading:false
        });
      }
    }catch(error){
      this.setState({
        buttonStatus: false,
        loading:false
      });
      // toast.error(error)

    }
  }

  onChangeDescription = (evt) => {
    const newContent = evt.getData();
    const trimmedString = newContent.replace(/\s|&nbsp;/g, "");
    trimmedString.length === 0 ||
    trimmedString.length === 7 ||
    trimmedString == "<p></p><p></p>"
      ? this.setState({ description: "" })
      : this.setState({ description: newContent });

    const plainText = newContent.replace(/<[^>]*>/g, "").trim(); // Strip HTML tags for char count
    const currentLength = plainText.length;
    this.setState({charCount: currentLength});
  };

  toggleRadioButton = (e) => {
    this.setState({ selectedOption: e });
    if (e === 1) {
      this.setState({ location: "" });
    } else {
      this.setState({ eventLink: "" });
    }
  };

  toggleButton = (e) => {
    this.setState({ selectLocation: parseInt(e.target.value,10) }, () => {});
  };

  toggleFlayer = (e) => {
    this.setState({ selectFlayer: e });
  };

  companyToggleButton = (e) => {
    this.setState({
      selectedCompanyCheckBox: e,
      companies: [],
      selectedCompanyValue: "",
    });
    if (e === 0) {
      this.setState({
        city_location: [],
      });
    }
  };

  inviteToggleButton = (e) => {
    this.setState({
      usersToInvite: e,
      // companies: [],
      // selectedCompanyValue: "",
    });
    if (e === 0) {
      this.setState({
        // city_location: [],
      });
    }
  };

  launchToggleButton = (e) => {
    this.setState({
      launch: e,
      // companies: [],
      // selectedCompanyValue: "",
    });
    if (e === 1) {
      this.setState( (prevState) => ({
        date:null,
        endDate:null,
        showDateTimeInput: prevState.showDateTimeInput === "date" ? "" : prevState.showDateTimeInput,
        // city_location: [],
      }));
    }
    if (e === 0) {
      this.setState((prevState) => ({
        date: dayjs(),
        endDate: null,
        // 👇 reset all-day selection if active
        showDateTimeInput: prevState.showDateTimeInput === "date" ? "" : prevState.showDateTimeInput,
      }));
    }
  };

  removeCommaFromFirstPlace = (str) => {
    if (str.charAt(0) === ",") {
      return str.substring(1);
    }
    return str;
  };

  wellnessCategories = [
    {
      name: "Nutrition Challenge",
      value: "nutrition",
    },
    {
      name: "Fitness Challenge",
      value: "fitness",
    },
    {
      name: "Workplace Challenge",
      value: "workplace",
    },
    {
      name: "Stress Challenge",
      value: "stress",
    },
    {
      name: "Health Challenge",
      value: "health",
    },
    {
      name: "Lifestyle Challenge",
      value: "lifestyle",
    },
  ];

  updateStep = (value) => {
    this.setState({ step: value, buttonClickScrollTop: true });
  };

  nextStep = (value) => {
    this.setState({
      step: value,
      buttonClickScrollTop: true,
      buttonStatus: false,
    });
  };

  isUrl = (eventUrl) => {
    const UrlRegex = /^(https?|ftp):\/\/[^\s/$.?#].[^\s]*$/;
    UrlRegex.test(eventUrl);
    if (UrlRegex.test(eventUrl)) {
      this.setState({
        iseventUrl: true,
        iseventUrlMsg: "",
      });
    } else {
      this.setState({
        iseventUrl: false,
        iseventUrlMsg: "Please enter valid URL",
      });
    }
  };

  close = () => (
    <svg
      width={24}
      height={24}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <mask
        id="mask0_14978_75731"
        style={{ maskType: "alpha" }}
        maskUnits="userSpaceOnUse"
        x={0}
        y={0}
        width={24}
        height={24}
      >
        <rect width={24} height={24} fill="#C4C4C4" />
      </mask>
      <g mask="url(#mask0_14978_75731)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M23.3605 0.678084C22.6358 -0.0466026 21.4608 -0.0466023 20.7361 0.678084L11.9067 9.50756L3.07795 0.678849C2.4145 0.0154025 1.33884 0.0154032 0.675399 0.678849C0.0119522 1.3423 0.0119521 2.41796 0.675399 3.0814L9.50411 11.9101L0.675642 20.7386C-0.0490441 21.4633 -0.0490441 22.6382 0.675643 23.3629C1.40033 24.0876 2.57528 24.0876 3.29996 23.3629L12.1284 14.5344L20.9577 23.3637C21.6211 24.0271 22.6968 24.0271 23.3602 23.3637C24.0237 22.7002 24.0237 21.6246 23.3602 20.9611L14.531 12.1319L23.3605 3.30241C24.0851 2.57772 24.0851 1.40277 23.3605 0.678084Z"
          fill="#9C9C9C"
        />
      </g>
    </svg>
  );

  redirect = () => {
    this.props.history.goBack();
  };

  removeHtmlTags = (str) => str.replace(/<[^>]*>/g, "");

  renderHeading = () => (
    // <ChallengeHeading color={"#005c87"}>
    //   <div style={{marginRight:"12px"}}>
    //     <HoverButton
    //       title={this.props.t("Close")}
    //       width="24px"
    //       height="24px"
    //       svgPath={this.close()}
    //       onClick={this.redirect}
    //       activeColor={"#007AB1"}
    //       fillOpacity={1}
    //     />
    //   </div>
    //   {this.props.t("Create Live Event")}
    // </ChallengeHeading>
    <FormHeading color={"#184A61"}>
      <div className="close-icon" onClick={this.redirect }>
        <ManagerIconContainer isWidth={"32px"}>{RecognitionCloseIcon('#F37A65')}</ManagerIconContainer>
      </div>
      {this.state.isCustomizedEvent ? "Launch Celebration Event" : this.state.isCelebrationEvent ?  "Create Celebration Event" : this.props.t("Launch Live Event")}
    </FormHeading>
  );

  stepOneForm = () => {
    const {
      title,
      description,
      step,
      charCount,
      // isCustomizedEvent
    } = this.state;
    const { t } = this.props;

    return (
      <Layout>
        <div className="main" >
          {this.renderHeading()}
          <Container height="100%" stepBackground="#005C87" color="#005C87" paddingForm>
            <div className="stepsNameHighlight">
              <StepsHeading stepCount={step} type="event" padding="20px 20px 265px 20px" />
            </div>
            <div className="form">
              {/* <div className="heading">
                <div className="step">{step}</div>
                <div className="headingName" style={{color:"#005c87"}}>{this.props.t("Event Introduction")}</div>
              </div> */}
              <div className="formBody">
                <InputContainer>
                  <StyledLabel isFont={"14px"} color={"#184A61"} margin="0px" symbolSize={"14px"}>{this.props.t("Title of the Event")}{<span>*</span>}</StyledLabel>
                  <StyledInputV2
                    placeholder={t("Enter title")}
                    name="title"
                    onChange={this.onChangeInput}
                    value={title}
                    maxLength="30"
                    style={{background:"white"}}
                    pColor={"#BDBDBD"}
                    color="#184A61"
                    border={"1px solid #BDBDBD"}
                    // disabled={isCustomizedEvent}
                  />
                  <div className="count">{title?.length}/30 | C</div>
                </InputContainer>
                <Border style={{ background: '#EFEFEF', margin: '20px 0 8px 0px' }} />

                <StyledLabel isFont={"14px"} color={"#184A61"} margin="0px" marginb="12px" symbolSize={"14px"}>{this.props.t("Event image")}{<span>*</span>} <span className="subtext">{("(use illustration)")}</span></StyledLabel>
                <CommonImageUploader
                  imgSrc={this.state.imgSrc}
                  t={t}
                  closeIcon={closeIcon}
                  UploadIcon={UploadHDMIcon}
                  onImageChange={this.onChange}
                  onRemoveImage={this.removePhoto}
                  // disabled={isCustomizedEvent}
                />

                {/* <UploadPhotoContainerV1>
                  <div className="innerDivImageContainer">
                    {this.state.imgSrc ? (
                      <RemoveImageV3>
                        <img alt="profilre-img" src={this.state.imgSrc}></img>
                        <div className="main-div" onClick={()=>!isCustomizedEvent && this.removePhoto}>
                          <div className="icon-div" ><div className="sub-icon-div">{closeIcon("#F37A65","8","8")}</div></div>
                        </div>
                      </RemoveImageV3>
                    ) : (
                      <div className="uploadImage">

                        <InputImageV1
                          className="edit-profile-pic "
                          imageReload={1} 
                          style={{background:"unset",color:"#005c87"}}
                        >
                          <div className="middle-section">
                            <div>{UploadHDMIcon(20,25)}</div>
                            <div className="title">{this.props.t("Upload File")}</div>
                            <div className="sub-title">{this.props.t("(.jpeg, .png)")}</div>
                            
                          </div>
                          <input
                            id="event-upload-file"
                            type="file"
                            name="user"
                            accept=".jpeg, .png, .jpg"
                            multiple={false}
                            onChange={(e) => this.onChange(e)}
                            onClick={(e) =>
                              e.target.files[0] && this.onChange(e)
                            }
                          />
                        </InputImageV1>
                      </div>
                    )}
                  </div>
                </UploadPhotoContainerV1> */}
                <Border style={{ background: '#EFEFEF', margin: '8px 0px'}}/>        
                <InputContainer  isColorError={charCount > 3000 ? true : false}>
                  <StyledLabel isFont={"14px"} color={"#184A61"} margin="0px" symbolSize={"14px"}>{this.props.t("About the Event")}{<span>*</span>}</StyledLabel>
                  <EditorContainer>
                    <Editor
                      content={description}
                      onChange={this.onChangeDescription}
                      // disabled={isCustomizedEvent}
                    />
                  </EditorContainer>
                  <div className="char-count">{charCount}/3000 | C</div>
                </InputContainer>
              </div>
            </div>
          </Container>
        </div>
      </Layout>
    );
  };

  DropdownIndicator = () => (
    <svg xmlns="http://www.w3.org/2000/svg" width="14" height="8" viewBox="0 0 14 8" fill="none">
      <path d="M12.16.5H1.842a.923.923 0 0 0-.646 1.578l5.149 5.149a.923.923 0 0 0 1.31 0l5.15-5.149A.923.923 0 0 0 12.158.5" fill="#F37A65"/>
    </svg>
  );

  toggleMenu = () => {
    this.setState((prevState) => ({
      menuIsOpen: !prevState.menuIsOpen,
    }));
  };

  onDropDownSelectCoach = (name, id, value) => {
    this.setState({
      [name]: id,
      coachName: value
    });
  };

  stepTwoThemeEventForm = ()=>{

    const{step,eventThemePointValue,participantingPointValue,eventPoints} =this.state;

    return(
      <Layout>
        <div className="main">
          {this.renderHeading()}
          <Container color={"#005c87"}>
            <div className="stepsNameHighlight">
              <StepsHeading stepCount={step} type="event" />
            </div>
            <div className="form">
              <div className="formBody">
                <div className="FormHeading">User participation</div>
                <Border style={{ background: '#EFEFEF', margin: '8px 0px' }} />

                <CommonDropdown
                  tileContainerStyle={{ width: "100%",padding:"0px 0px 12px 0px" }}
                  dropdownStyle={{ top: "90px" }}
                  labelText={this.props.t("Event point value")}
                  isRequired={true}
                  dropdownOpen={this.state.so}
                  placeholder={this.props.t("Select point")}
                  title={
                    eventThemePointValue !== null && eventThemePointValue !== undefined
                      ? `${eventThemePointValue} pts`
                      : ""}
                  id="dropdown-recurring"
                  onClick={() => this.setState({ so: !this.state.so })}
                  data={eventPoints}
                  onSelect={this.onSelectPointsThemeEvent}
                  active={eventThemePointValue}
                  onSelectParameter={["eventPointValue", "value", "key"]}
                  valueString={"Points"}
                  itemValue={true}
                  valueIndex={1}
                  dropIcon={true}
                  labelMargin={"0px"}
                  fontSize={"14px"}
                />
                <Border style={{display:"flex", background: '#EFEFEF', margin: '12px 0px' }}/>
                <CommonDropdown
                  tileContainerStyle={{ width: "100%",padding:"0px 0px 8px 0px" }}
                  dropdownStyle={{ top: "90px" }}
                  labelText={this.props.t("Points for Participating in Moments")}
                  isRequired={true}
                  dropdownOpen={this.state.so}
                  placeholder={this.props.t("Select point")}
                  title={
                    participantingPointValue !== null && participantingPointValue !== undefined
                      ? `${participantingPointValue} pts`
                      : ""}
                  id="dropdown-recurring"
                  onClick={() => this.setState({ so: !this.state.so })}
                  data={wellnessChallengePoints}
                  onSelect={this.onSelectPointsParticipation}
                  active={participantingPointValue}
                  onSelectParameter={["eventPointValue", "value", "key"]}
                  valueString={"Points"}
                  itemValue={true}
                  valueIndex={1}
                  dropIcon={true}
                  labelMargin={"0px"}
                  fontSize={"14px"}
                />
              </div>

            </div>
          </Container>
        </div>
      </Layout>
    )
  }
       




  stepTwoForm = () => {
    const {
      step,
      iseventUrlMsg,
      location,
      eventLink,
      addLimitCheckbox,
      selectedOption,
      eventPointValue,
      eventPoints,
      flayerName,
      coachId,
      coachName,
      getCoachData,
      limitUser,
      /*flayerValue,*/ selectFlayer,
      // progress,
    } = this.state;
    const { t } = this.props;


    return (
      <Layout>
        <div className="main">
          {this.renderHeading()}
          <Container color={"#005c87"}>
            <div className="stepsNameHighlight">
              <StepsHeading stepCount={step} type="event" />
            </div>
            <div className="form">
              {/* <div className="heading">
                <div className="step">{step}</div>
                <div className="headingName">
                  {this.props.t("How would you like to customize your event?")}
                </div>
              </div> */}
              <div className="formBody">
                <div>

                  <StyledLabel isFont={"14px"} color={"#184A61"} margin="0px" symbolSize={"14px"}>{this.props.t("Type of event")}?{<span>*</span>}</StyledLabel>
                  <div className="radioButtonDiv">
                    <span onClick={() => this.toggleRadioButton(0)}>
                      <RadioButtonNew
                        id="onsite"
                        handler={this.toggleRadioButton}
                        value={0}
                        isChecked={selectedOption === 0}
                        label={t("Onsite Event")}
                        challengeCreate={true}
                      />
                    </span>
                    <span onClick={() => this.toggleRadioButton(1)}>
                      <RadioButtonNew
                        id="virtual"
                        handler={this.toggleRadioButton}
                        value={1}
                        isChecked={selectedOption === 1}
                        label={t("Virtual Event")}
                        challengeCreate={true}
                      />
                    </span>
                  </div>
                  <Border style={{ background: '#EFEFEF', margin: '8px 0px'}}/> 
                
                  {selectedOption === 0 ? (
                    <>
                      <StyledLabel isFont={"14px"} color={"#184A61"} margin="0px" symbolSize={"14px"}>{this.props.t("Event Location")}{<span>*</span>}</StyledLabel>   
                      <StyledInputV2
                        placeholder={t("Enter conference room number, location, etc")}
                        name="location"
                        value={location}
                        onChange={this.onLocationChange}
                        locationInput
                        bgColor={"white"}
                        style={{background:"white"}}
                        pColor={"#BDBDBD"}
                        color="#184A61"
                        border={"1px solid #BDBDBD"}
                      /></>
                  ) : (
                    <React.Fragment>
                      <StyledLabel isFont={"14px"} color={"#184A61"} margin="0px" symbolSize={"14px"}>{this.props.t("URL")}{<span>*</span>}</StyledLabel>   
                      <StyledInputV2
                        placeholder={t("Enter event URL")}
                        name="eventLink"
                        onChange={this.onChangeInput}
                        value={eventLink}
                        bgColor={"white"}
                        style={{background:"white"}}
                        pColor={"#BDBDBD"}
                        color="#184A61"
                        border={"1px solid #BDBDBD"}
                      />
                      <span style={{ color: "#DA6C74",fontFamily: "Lato",fontSize: '12px'}}>{iseventUrlMsg}</span>
                    </React.Fragment>
                  )}
                  <Border style={{ background: '#EFEFEF', margin: '8px 0px' }} />
                  <InputContainer>
                    <StyledLabelV2 isFont={"14px"} color={"#184A61 !important"} symbolSize={"14px"} marginB={"12px"}>
                      <div className="name">
                        {this.props.t("Event limit users")}{<span>*</span>}
                      </div>
                    </StyledLabelV2>
                    <RadioContainer justify>
                      <span style={{width:"auto", display:"flex",alignItems:"center",cursor:"pointer", marginRight:"84px"}}   onClick={() => this.changeLimitCheckBox(false)}>
                        <CustomRadioButtonNew
                          onClick={() => this.changeLimitCheckBox(false)}
                          isChecked={!addLimitCheckbox}
                          background={"#85c0ea"}
                        >
                          {" "}
                          {!addLimitCheckbox && <div></div>}
                        </CustomRadioButtonNew>
                        {this.props.t("No Limit")}
                      </span>
                      <span style={{width:"auto", display:"flex",alignItems:"center",cursor:"pointer"}}   onClick={() => this.changeLimitCheckBox(true)}>
                        <CustomRadioButtonNew
                          onClick={() => this.changeLimitCheckBox(true)}
                          isChecked={addLimitCheckbox}
                          background={"#85c0ea"}
                        >
                          {" "}
                          {addLimitCheckbox && <div></div>}
                        </CustomRadioButtonNew>
                        {this.props.t("Add Limit")}
                      </span>
                    </RadioContainer>
                    <Border style={{ background: '#EFEFEF', margin: '8px 0px' }} />
                    {addLimitCheckbox ? <><StyledLabel isFont={"14px"} color={"#184A61"} margin="0px" symbolSize={"14px"} marginb={"12px"}>{this.props.t("Event limit")}{<span>*</span>}</StyledLabel>   
                      <StyledInputV2
                        placeholder={t("Add event user limit")}
                        type={addLimitCheckbox ? "number" : "text"}
                        name="limitUser"
                        onChange={this.onChangeInput}
                        value={limitUser !== "" ? parseInt(limitUser,10) : ""}
                        min="1"
                        pattern="[0-9]*"
                        disabled={!addLimitCheckbox}
                        bgColor={"white"}
                        style={{background:"white"}}
                        pColor={"#BDBDBD"}
                        color="#184A61"
                        border={"1px solid #BDBDBD"}
                      />
                      <Border style={{ background: '#EFEFEF', margin: '8px 0px' }} />
                    </> :null}
                  </InputContainer>
                  <CommonDropdown
                    tileContainerStyle={{ width: "100%",padding:"0px 0px 8px 0px" }}
                    dropdownStyle={{ top: "90px" }}
                    labelText={this.props.t("Event point value")}
                    isRequired={true}
                    dropdownOpen={this.state.so}
                    placeholder={this.props.t("Select point")}
                    title={
                      eventPointValue !== null && eventPointValue !== undefined
                        ? `${eventPointValue} pts`
                        : ""}
                    id="dropdown-recurring"
                    onClick={() => this.setState({ so: !this.state.so })}
                    data={eventPoints}
                    onSelect={this.onSelectPoints}
                    active={eventPointValue}
                    onSelectParameter={["eventPointValue", "value", "key"]}
                    valueString={"Points"}
                    itemValue={true}
                    valueIndex={1}
                    dropIcon={true}
                    labelMargin={"0px"}
                    fontSize={"14px"}
                  />
                  
                  <Border style={{background:'#EFEFEF',margin:'8px 0px', display:"flex"}}/>

                  {<TitleContainer padding="0px 0px 8px 0px">
                    <StyledLabel isFont={"14px"} color={"#184A61"} margin="0px" marginb={"0px"}>{this.props.t("Event Host")}{<span>*</span>}</StyledLabel>
                    <NewActivityDropdownCommon
                      onClick={() => this.setState({ so3: !this.state.so3 })}
                    >
                      <Dropdown.Toggle>
                        <div style={{display:"flex",justifyContent:"space-between",alignItems:"center"}}><div style={{color: !coachName&& "#BDBDBD" }}>{getCoachData?.length==0?"None":  coachName?coachName:"Select event host"}</div>
                          <div style={{position:"realtive"}}>
                            {getCoachData?.length>0 &&<div style={{position:"absolute",right:"16px",top:"18px",cursor:"pointer"}} onClick={() => this.setState({ so3: !this.state.so3 })}>
                              {DropIcon("#F37A65")}
                            </div>}
                          </div>
                        </div>
                      </Dropdown.Toggle>
                      {getCoachData?.length>0 &&<Dropdown.Menu>
                        {getCoachData?.length>0 && getCoachData.map((item, index) => (
                          <Dropdown.Item
                            eventKey={index}
                            key={index}
                            onClick={() =>
                              this.onDropDownSelectCoach("coachId", item.id, item.name)
                            }
                            active={coachId === item.id}
                          >
                            {item.name}
                          </Dropdown.Item>
                        ))}
                      </Dropdown.Menu>}
                    </NewActivityDropdownCommon>
                  </TitleContainer>}
                  <Border style={{background:'#EFEFEF',margin:'8px 0px',display:"flex"}}/>
                  <StyledLabel isFont={"14px"} color={"#184A61"} margin="0px" symbolSize={"14px"}>
                    {this.props.t("Would you like to add promotional document?")} {<span>*</span>}
                  </StyledLabel>
                  <div className="radioButtonDiv">
                    <span onClick={() => this.toggleFlayer(0)} style={{marginRight:"120px"}}>
                      <RadioButtonNew
                        id="flyer-yes"
                        handler={this.toggleFlayer}
                        value={0}
                        isChecked={selectFlayer === 0}
                        label={"Yes"}
                        challengeCreate={true}
                      />
                    </span>
                    <span onClick={() => this.toggleFlayer(1)}>
                      <RadioButtonNew
                        id="flyer-no"
                        handler={this.toggleFlayer}
                        value={1}
                        isChecked={selectFlayer === 1}
                        label={"No"}
                        challengeCreate={true}
                      />
                    </span>
                  </div>

                  

                  {selectFlayer === 0 && (
                    <>
                      <Border style={{background:'#EFEFEF',margin:'8px 0px',display:"flex"}}/>
                      <StyledLabel isFont={"14px"} color={"#184A61"} margin="0px" symbolSize={"14px"}>
                        {this.props.t("Add promotional document")} {<span>*</span>}
                      </StyledLabel>
                      <CommonImageUploader
                        imgSrc={this.state.flayerValue}
                        t={t}
                        closeIcon={closeIcon}
                        UploadIcon={UploadHDMIcon}
                        onImageChange={this.uploadPDFFile}
                        onRemoveImage={()=>flayerName ? this.removePDF() : ""}
                        type={'promotional'}
                        imageName={this.state.flayerName}
                      />



                      {/* <UploadPhotoContainerV1>
                        <div className="innerDivImageContainer">
                          <div className="uploadImage">
 
                            <InputImageV1
                              className="edit-profile-pic "
                              imageReload={1} 
                              style={{background:"unset",color:"#005c87",width:"100%", display:"flex",alignItems:"center",justifyContent:"center"}}
                            >
                              <div className="middle-section" style={{textAlign:"center"}}>
                                {flayerName
                                  ? (<React.Fragment>   
                                    <CircleNew width="64px" height="64px" marginT="0px">
                                      <div style={{width:"64px",height:"64px"}}>{PromotionalDocIcon()}</div>
                                    </CircleNew>                           
                                    <span className="flyer-name">{flayerName}</span></React.Fragment>)
                                  : (<React.Fragment>                              
                                    <div>{UploadHDMIcon(20,25)}</div>
                                    <div className="title">{this.props.t("Upload File")}</div>
                                    <div className="sub-title">{this.props.t("(.pdf, .jpeg, .png)")}</div></React.Fragment>)}
                              </div>
                              <input
                                id="event-upload-file"
                                type="file"
                                name="user"
                                accept=".jpeg, .png, .jpg, .pdf"
                                multiple={false}
                                onChange={(e) => this.uploadPDFFile(e)}
                                onClick={(e) =>
                                  e.target.files[0] && this.uploadPDFFile(e)
                                }
                              />
                            </InputImageV1>
                            {flayerName && ( 
                              <RemoveImageV3>
                                <div className="main-div" onClick={flayerName ? () => this.removePDF() : ""}>
                                  <div className="icon-div" ><div className="sub-icon-div">{closeIcon("#F37A65","8","8")}</div></div>
                                </div>
                              </RemoveImageV3>)}
                          </div>
                        </div>
                      </UploadPhotoContainerV1> */}
                    </>)}
                  {/* {selectFlayer === 0 ? (
                    <FlayerMain active={flayerName} width={progress} background="white" border="1px solid #afcbd3" buttonBgColor="#005c87" pBarBgColor="#005c87" color="#005c87">
                      <div className="uploadImage">
                        <img
                          alt="profilre-img"
                          src={"/public/images/UploadIcon.png"}
                        ></img>
                      </div>
                      <div className="fileMain">
                        <div className="fileName">
                          {flayerName
                            ? flayerName
                            : "Select a .pdf, .jpg and .png file to upload"}
                        </div>
                        {flayerName && (
                          <div className="progressBar">
                            <div className="progressValue"></div>
                          </div>
                        )}
                      </div>
                      {flayerName ? (
                        <div
                          className="button"
                          onClick={flayerName ? () => this.removePDF() : ""}
                        >
                          {flayerName ? this.props.t("Remove") : this.props.t("Upload")}
                        </div>
                      ) : (
                        <div className="button">
                          {flayerName ? this.props.t("Remove") : this.props.t("Upload")}
                          <input
                            id="event-upload-file"
                            type="file"
                            name="user"
                            accept=".jpeg, .png, .jpg, .pdf"
                            multiple={false}
                            onChange={(e) => this.uploadPDFFile(e)}
                            onClick={(e) =>
                              e.target.files[0] && this.uploadPDFFile(e)
                            }
                          />
                        </div>
                      )}
                    </FlayerMain>
                  ) : null} */}
                  
                </div>
              </div>
            </div>
          </Container>
        </div>
      </Layout>
    );
  };

  stepThreeForm = () => {
    const {
      companies,
      city_location,
      companiesPermission,
      step,
      selectedCompanyValue,
      selectedCompanyCheckBox,
      isEmployee,
      isDependent,
      isSpouse,
      usersToInvite,
      allTeams,
      filteredCompanies,
      departments,
      teams,
      companyInfo,
      isCustomizedEvent
    } = this.state;
    const { allCompanies, locationDetails, t, role, /*companyDetails,*/ departmentDetails, isAccountManager } = this.props;
    let enabledCompanies = allCompanies?.filter((company) => company.show_events === 1);
    return (
      <Layout>
        <div className="main">
          {this.renderHeading()}
          <Container color={"#005c87"} isFormPadding={"13px"}>
            <div className="stepsNameHighlight">
              <StepsHeading stepCount={step} type="event" />
            </div>
            <div className="form">
              {/* <div className="heading">
                <div className="step">{step}</div>
                <div className="headingName">{this.props.t("Who would you like to invite?")}</div>
              </div> */}
              <div className="formBody">
                {(companiesPermission||isAccountManager) && (
                  <StyledLabel isFont={"14px"} color={"#184A61"} margin="0px" symbolSize={"14px"} marginb={"12px"}>
                    {this.props.t("Host your event for?")}{<span>*</span>}
                  </StyledLabel>
                )}
                {(companiesPermission||isAccountManager) && (
                  <div className="radioButtonDiv">
                    {isCustomizedEvent ? null :<span onClick={() => this.companyToggleButton(0)} style={{marginRight:"160px"}}>
                      <RadioButtonNew
                        id="global"
                        handler={this.companyToggleButton}
                        value={0}
                        isChecked={selectedCompanyCheckBox === 0}
                        label={t("Global")}
                        challengeCreate={true}
                      />
                    </span>}
                    <span onClick={() => this.companyToggleButton(1)}>
                      <RadioButtonNew
                        id="company"
                        handler={this.companyToggleButton}
                        value={1}
                        isChecked={selectedCompanyCheckBox === 1}
                        label={t("For an Individual Company")}
                        challengeCreate={true}
                      />
                    </span>
                  </div>
                )}
             
                {(companiesPermission||isAccountManager) ? (<>
                  <Border style={{ background: '#EFEFEF', margin: '12px 0px'}}/> 
                  <Heading>
                    <div className="name" style={{ color: "#184A61", marginBottom: "12px" }}>
                      {this.props.t(`Search company you want to add`)} &nbsp; 
                      {selectedCompanyCheckBox === 1 ? null : <span>
                        {companies.length > 0 
                          ? `(${companies.length} ${companies.length === 1 ? "Company" : "Companies"} Selected)` 
                          : ""}
                      </span>}
                    </div>


                    {/* <div className="name" style={{color:"#184A61",marginBottom:"12px"}}>
                      {this.props.t(`Search company you want to add`)} &nbsp;
                      <span> 
                        { companies.length > 0 ? "(" + companies.length + " Companies Selected)" : ""}
                      </span>
                    </div> */}
                  </Heading>
                  <SearchFilter1 style={{width:"515px",maxWidth:"515px"}} isMargin={"12px 0px"} isBgColor="none">
                    <StyledInputV2
                      pColor={"#BDBDBD"}
                      color="#184A61"
                      isPadding={"8px 16px"}
                      isBorderColor={"1px solid #BDBDBD"}
                      type="text" placeholder={t("Search")}
                      value={this.state.searchTerm} 
                      onChange={this.handleSearch} 
                      // onKeyDown={this.handleKeyDown}
                      style={{border:"none",height:'36px'}}
                    />
                    {/* <SearchIcon> {SearchButtonIcon()}</SearchIcon> */}
                  </SearchFilter1>


                  {selectedCompanyCheckBox === 0 && !isCustomizedEvent ?<> <AllCompaniesContainer>
                    <span>
                      <CustomCheckBoxButton
                        isSelected={companies.length === enabledCompanies.length}
                        onClick={(e) =>
                          this.selectAllCompanies(e, enabledCompanies)
                        }
                        
                        background={"#85c0ea"}
                      >
                        {" "}
                        {enabledCompanies &&
                          companies.length === enabledCompanies.length && (
                          <div>{RecognitionTickIcon()}</div>
                        )}{" "}
                      </CustomCheckBoxButton>{" "}
                      {this.props.t("All Companies")}
                    </span>
                  </AllCompaniesContainer>
                  <Border style={{background:'#EFEFEF',margin:'8px 0px', display:"flex"}}/></>: null} 

                 
    
                  <Locationwrapper style={{gap:"0px 8px"}} background="white" isColor={"#092F41"} isWidth={"24%"} marginTop={selectedCompanyCheckBox === 0 ? "12px" : "24px"}>
                   
                    {filteredCompanies && filteredCompanies.length > 0
                      ? filteredCompanies.map((company, index) => (
                        <div className="checkBoxWidth" key={index}>
                          <div
                            style={{
                              display: "flex",
                              alignItems: "center",
                              width: "100%",
                              maxWidth: "100%",
                            }}
                          >
                            <CustomCheckBoxButton
                              isDisabled={company.show_events === 0}
                              isSelected={companies.includes(company.id)}
                              onClick={() =>{
                                company.show_events === 0 ? undefined :
                                  selectedCompanyCheckBox === 0 ? this.onCheckboxChange(company.id,company.company_name) : selectedCompanyCheckBox === 1 ? this.onSelectLocation(company) : null
                              }
                              }
                              background="#afcbd3"
                              id={company.id + "1"}
                            >
                              {companies.includes(company.id) && ( <div>{RecognitionTickIcon()}</div>)}
                            </CustomCheckBoxButton>
                            <div style={{
                              color: company.show_events === 0 ? '#BDBDBD' : '#092F41',
                              cursor: company.show_events === 0 ? 'not-allowed' : 'pointer',
                              overflow: "hidden",
                              textOverflow: "ellipsis",
                              whiteSpace: "nowrap",
                              flex: 1,
                              fontFamily:"Lato",
                              fontSize:"16px",
                              fontWeight: 400,
                            }}
                            title={company.company_name} >
                              {company.company_name}
                            </div>
                          </div> </div>
                      )): null}
                  </Locationwrapper>


                </>) : null}


                {(role === "ADMIN"||isAccountManager) && (<Border style={{background:'#EFEFEF',margin:'8px 0px'}}/>)}

                {companies?.length > 0 ? (<><StyledLabel isFont={"14px"} color={"#184A61"} margin="0px" symbolSize={"14px"} marginb={"12px"}>
                  {this.props.t("Who would you like to invite?")}{<span>*</span>}
                </StyledLabel>
                <div className="radioButtonDiv" style={{zIndex:"10",position:"relative",gap:"60px"}}>
                  <span onClick={() => this.inviteToggleButton(0)} style={{width:"163px"}}>
                    <RadioButtonNew
                      id="all-users"
                      handler={this.inviteToggleButton}
                      value={0}
                      isChecked={usersToInvite === 0}
                      label={t("All Users")}
                      challengeCreate={true}
                    />
                  </span>
                  {((role != "ADMIN"&&!isAccountManager) || selectedCompanyCheckBox === 1) && departmentDetails?.length > 0 &&(<span onClick={() => this.inviteToggleButton(1)} style={{width:"163px"}}>
                    <RadioButtonNew
                      id="departments"
                      handler={this.inviteToggleButton}
                      value={1}
                      isChecked={usersToInvite === 1}
                      label={t("Departments")}
                      challengeCreate={true}
                    />
                  </span>)}
                  {((role != "ADMIN"&&!isAccountManager) || selectedCompanyCheckBox === 1) && locationDetails?.length > 0 &&(<span onClick={() => this.inviteToggleButton(2)} style={{width:"163px"}}>
                    <RadioButtonNew
                      id="locations"
                      handler={this.inviteToggleButton}
                      value={2}
                      isChecked={usersToInvite === 2}
                      label={t("Locations")}
                      challengeCreate={true}
                    />
                  </span>)}
                  {((role != "ADMIN"&&!isAccountManager) || selectedCompanyCheckBox === 1) && allTeams.length > 0 &&( <span onClick={() => this.inviteToggleButton(3)} style={{width:"163px"}}>
                    <RadioButtonNew
                      id="teams"
                      handler={this.inviteToggleButton}
                      value={3}
                      isChecked={usersToInvite === 3}
                      label={t("Teams")}
                      challengeCreate={true}
                    />
                  </span>)}
                </div></>):null}
                {((role === "ADMIN"||isAccountManager) &&
                  locationDetails && 
                  locationDetails?.length > 0 &&
                  selectedCompanyCheckBox === 1 &&
                  selectedCompanyValue.length > 0 && usersToInvite === 2) ||
                (locationDetails &&
                  locationDetails?.length > 0 &&
                  (role != "ADMIN"&&!isAccountManager)  && usersToInvite === 2 ) ? (<StyledLabel isFont={"14px"} color={"#184A61"} margin="0px" symbolSize={"14px"} marginb={"12px"}>
                    {this.props.t("Select Locations")}{<span>*</span>}
               
                    {/* <div className="selectAllRadio">
                      <span style={{color:"#005c87"}}>
                        <CustomRadioButton
                          onClick={(e) =>
                            this.selectAllLocation(e, locationDetails)
                          }
                          
                          background={"#85c0ea"}
                        >
                          {" "}
                          {locationDetails &&
                            city_location.length === locationDetails.length && (<div></div>)}{" "}
                        </CustomRadioButton>{" "}
                        {locationDetails &&
                        city_location.length === locationDetails.length
                          ? this.props.t("Deselect All")
                          : this.props.t("Select All")}
                      </span>
                    </div> */}
                  </StyledLabel>
                  ) : null}
                {((role === "ADMIN"||isAccountManager) &&
                usersToInvite === 2 && locationDetails &&
                  locationDetails.length > 0 &&
                  selectedCompanyCheckBox === 1 &&
                  selectedCompanyValue.length > 0) ||
                (locationDetails &&
                  locationDetails.length > 0 &&
                  (role != "ADMIN"&&!isAccountManager)  && usersToInvite === 2 ) ? (
                    <Locationwrapper  background="white" style={{zIndex:"10",position:"relative"}} isWidth={"24.33%"}> 
                      <div className="checkBoxWidth" >
                        <span>
                          <CustomCheckBoxButton
                            isSelected={locationDetails && city_location.length === locationDetails.length}
                            onClick={(e) =>
                              this.selectAllLocation(e, locationDetails)
                            }
                            
                            background={"#85c0ea"}
                          >
                            {" "}
                            {locationDetails &&
                              city_location.length === locationDetails.length && (<div>{RecognitionTickIcon()}</div>)}
                          </CustomCheckBoxButton>{" "}
                          {this.props.t("All Locations")}
                          {/* {locationDetails &&
                          city_location.length === locationDetails.length
                            ? this.props.t("Deselect All")
                            : this.props.t("Select All")} */}
                        </span>
                      </div>
                      {locationDetails && locationDetails.length > 0
                        ? locationDetails.map((loc, index) => (
                          <div className="checkBoxWidth" key={index}>
                            <span>
                              <CustomCheckBoxButton
                                isSelected={city_location.includes(loc.id)}
                                onClick={() => this.onChangeLocation(loc.id)}
                                background="#afcbd3"
                              >
                                {" "}
                                {city_location.includes(loc.id) && (
                                  <div>{RecognitionTickIcon()}</div>
                                )}{" "}
                              </CustomCheckBoxButton>
                              {this.removeCommaFromFirstPlace(loc.location)}
                            </span>
                          </div>
                        ))
                        : null}
                    </Locationwrapper>
                  ) : null}

                {/* Dpartment Listing */}

                {((role === "ADMIN"||isAccountManager) &&
                  departmentDetails && 
                  departmentDetails?.length > 0 &&
                  selectedCompanyCheckBox === 1 &&
                  selectedCompanyValue.length > 0 && usersToInvite === 1) ||
                (departmentDetails &&
                  departmentDetails?.length > 0 &&
                  (role != "ADMIN"&&!isAccountManager)  && usersToInvite === 1 ) ? (<StyledLabel isFont={"14px"} color={"#184A61"} margin="0px" symbolSize={"14px"} marginb={"12px"}>
                    {this.props.t("Select Departments")}{<span>*</span>}
                  </StyledLabel>
                  ) : null}
                {((role === "ADMIN"||isAccountManager) &&
                usersToInvite === 1 && departmentDetails &&
                  departmentDetails?.length > 0 &&
                  selectedCompanyCheckBox === 1 &&
                  selectedCompanyValue.length > 0) ||
                (departmentDetails &&
                  departmentDetails?.length > 0 &&
                  (role != "ADMIN"&&!isAccountManager)  && usersToInvite === 1 ) ? (
                    <Locationwrapper  background="white" style={{zIndex:"10",position:"relative"}} isWidth={"24.33%"}>
                      <div className="checkBoxWidth" >
                        <span>
                          <CustomCheckBoxButton
                            isSelected={departmentDetails && departments?.length === departmentDetails?.length}
                            onClick={(e) =>
                              this.selectAllDepartment(e, departmentDetails)
                            }
                            
                            background={"#85c0ea"}
                          >
                            {" "}
                            {departmentDetails &&
                              departments?.length === departmentDetails?.length && (<div>{RecognitionTickIcon()}</div>)}{" "}
                          </CustomCheckBoxButton>{" "}
                          {departmentDetails &&
                          departments.length === departmentDetails?.length
                            ? this.props.t("Deselect All")
                            : this.props.t("Select All")}
                        </span>
                      </div>
                      {departmentDetails && departmentDetails?.length > 0
                        ? departmentDetails.map((dep, index) => (
                          <div className="checkBoxWidth" key={index}>
                            <span>
                              <CustomCheckBoxButton
                                isSelected={departments.includes(dep.id)}
                                onClick={() => this.onChangeDepartment(dep.id)}
                                background="#afcbd3"
                              >
                                {" "}
                                {departments.includes(dep.id) && (
                                  <div>{RecognitionTickIcon()}</div>
                                )}{" "}
                              </CustomCheckBoxButton>
                              {this.removeCommaFromFirstPlace(dep.department)}
                            </span>
                          </div>
                        ))
                        : null}
                    </Locationwrapper>
                  ) : null}

                {/* Teams Listing */}

                {((role === "ADMIN"||isAccountManager) &&
                  allTeams && 
                  allTeams.length > 0 &&
                  selectedCompanyCheckBox === 1 &&
                  selectedCompanyValue.length > 0 && usersToInvite === 3) ||
                (allTeams &&
                  allTeams.length > 0 &&
                  (role != "ADMIN"&&!isAccountManager)  && usersToInvite === 3 ) ? (<StyledLabel isFont={"14px"} color={"#184A61"} margin="0px" symbolSize={"14px"} marginb={"12px"}>
                    {this.props.t("Select Teams")}{<span>*</span>}
                  </StyledLabel>
                  ) : null}
                {((role === "ADMIN"||isAccountManager) &&
                usersToInvite === 3 && allTeams &&
                  allTeams.length > 0 &&
                  selectedCompanyCheckBox === 1 &&
                  selectedCompanyValue.length > 0) ||
                (allTeams &&
                  allTeams.length > 0 &&
                  (role != "ADMIN"&&!isAccountManager)  && usersToInvite === 3 ) ? (
                    <Locationwrapper  background="white" style={{zIndex:"10",position:"relative"}} isWidth={"24.33%"}>
                      <div className="checkBoxWidth" >
                        <span>
                          <CustomCheckBoxButton
                            isSelected={allTeams && teams.length === allTeams.length}
                            onClick={(e) =>
                              this.selectAllTeam(e, allTeams)
                            }
                            
                            background={"#85c0ea"}
                          >
                            {" "}
                            {allTeams &&
                              teams.length === allTeams.length && ( <div>{RecognitionTickIcon()}</div>)}{" "}
                          </CustomCheckBoxButton>{" "}
                          {allTeams &&
                          teams.length === allTeams.length
                            ? this.props.t("Deselect All")
                            : this.props.t("Select All")}
                        </span>
                      </div>
                      {allTeams && allTeams.length > 0
                        ? allTeams.map((team, index) => (
                          <div className="checkBoxWidth" key={index + team}>
                            <span>
                              <CustomCheckBoxButton 
                                isSelected={teams.includes(team.id)}
                                onClick={() => this.onChangeTeam(team.id)}
                                background="#afcbd3"
                              >
                                {" "}
                                {teams.includes(team.id) && (
                                  <div>{RecognitionTickIcon()}</div>
                                )}{" "}
                              </CustomCheckBoxButton>
                              {this.removeCommaFromFirstPlace(team.name)}
                            </span>
                          </div>
                        ))
                        : null}
                    </Locationwrapper>
                  ) : null}

                {(companyInfo?.show_spouse || companyInfo?.show_dependent ||  (locationDetails?.length === 0 && usersToInvite === 2)) && companies?.length > 0 && ((role !== "ADMIN"&&!isAccountManager) || selectedCompanyCheckBox === 1)  ? ( <Border style={{background:'#EFEFEF',margin:'4px 0px'}}/>) : null}

                {/* Spouse Dependent */}


                {(companyInfo?.show_spouse || companyInfo?.show_dependent ||  (locationDetails?.length === 0 && usersToInvite === 2)) && companies?.length > 0 && ((role !== "ADMIN"&&!isAccountManager) || selectedCompanyCheckBox === 1)  ? (                 
                  <StyledLabel isFont={"14px"} color={"#184A61"} margin="0px" marginb={"12px"}>
                    {this.props.t("Are you also interested in extending an invitation?")}
                  </StyledLabel>) : null}
                {companies?.length > 0 && ((role !== "ADMIN"&&!isAccountManager) || selectedCompanyCheckBox === 1) ? <Locationwrapper  background="white">
                  {companyInfo?.show_spouse ?<div className="checkBoxWidth">
                    <span>
                      <CustomCheckBoxButton
                        isSelected={isSpouse}
                        onClick={() => this.selectSpouseDependent("isSpouse")}
                        background="#afcbd3"
                      >
                        {" "}
                        {isSpouse && (
                          <div>{RecognitionTickIcon()}</div>
                        )}{" "}
                      </CustomCheckBoxButton>
                      {this.props.t("Spouse")}
                    </span>
                  </div>:null}
                  {companyInfo?.show_dependent ?<div className="checkBoxWidth">
                    <span>
                      <CustomCheckBoxButton
                        isSelected={isDependent}
                        onClick={() =>
                          this.selectSpouseDependent("isDependent")
                        }
                      >
                        {" "}
                        {isDependent && (
                          <div>{RecognitionTickIcon()}</div>
                        )}{" "}
                      </CustomCheckBoxButton>
                      {this.props.t("Dependent")}
                    </span>
                  </div>:null}
                  {locationDetails?.length === 0 && usersToInvite === 2 &&  (
                    <div className="checkBoxWidth">
                      <span>
                        <CustomCheckBoxButton
                          isSelected={isEmployee}
                          onClick={() =>
                            this.selectSpouseDependent("isEmployee")
                          }
                        >
                          {" "}
                          {isEmployee && (
                            <div>{RecognitionTickIcon()}</div>
                          )}{" "}
                        </CustomCheckBoxButton>
                        {this.props.t("Employee")}
                      </span>{" "}
                    </div>
                  )}
                </Locationwrapper>:null}


                {/* Spouse Dependent */}
              </div>
            </div>
          </Container>
        </div>
      </Layout>
    );
  };


  hideShowCalendarPopup = (value) =>{
    this.setState({
      datePopup: value,
      showDatePopupModal: true
    })
  }

  removePDF = () => {
    this.setState({
      flayerValue: "",
      flayerName: "",
      progress: 0,
    });
  };

  setEmailerTemplateData = ()=>{
    const { title,date,eventLink, location } = this.state;
    const emailerData = [ 
      {
        "template_type": "3_DAYS_BEFORE",
        "template_subject": `Ready to Relax? ${title} event is Almost Here`,
        "template_text": `<p>Mark your calendar!<br><br>${title} event is coming up on ${dayjs(date).format('MMM D, YYYY')}, and it's going to be fun and insightful.<br><br>🕒 When: ${dayjs(date).format('MMM D, YYYY')}&nbsp;<br>📍 Where: ${eventLink ? "Virtual" : location}<br><br>Spots may be limited—secure yours now!</p>`,
        "template_cta_text": "Save My Spot",
        "template_signature_text": "<p>Cheers,<br>The Woliba Team</p>"
      },
      {
        "template_type": "1_DAY_BEFORE",
        "template_subject": `We Can’t Wait to See You at ${title} event Tomorrow`,
        "template_text": `<p>Tomorrow’s the day!<br>You’re all set to join ${title} event, and we’re excited to have you.<br>Check the time: ${dayjs(date).format('MMM D, YYYY | h a')}</p>`,
        "template_cta_text": "Save My Spot",
        "template_signature_text": "<p>Cheers,<br>The Woliba Team</p>"
      },
      {
        "template_type": "1_HOUR_BEFORE",
        "template_subject": `It’s Almost Go Time – ${title} event`,
        "template_text": `<p>Just a heads up—${title} event kicks off in about an hour!<br>You can still jump in and join us</p>`,
        "template_cta_text": "View Event",
        "template_signature_text": "<p>Cheers,<br>The Woliba Team</p>"
      }
    ]
    this.setState({emailerTemplatesData:emailerData})
  }

  stepFourForm = () => {
    const {
      step,
      showDateTimeInput,
      date,
      endDate,
      iseventUrl,
      // time,
      // endTime,
      // openDateTimePicker,
      time_zone,
      recurringEvent,
      eventLimitValue,
      // menuIsOpen,
      companiesPermission,
      // selectedCompanyCheckBox,
      launch,
      datePopup,
      showDatePopupModal,
      selectedOption
    } = this.state;


    const { t, isAccountManager } = this.props;

    // const yesterday = Datetime.moment().subtract(23, "hour");
    // const valid = (currentDate) =>
    //   showDateTimeInput === "date"
    //     ? currentDate.isAfter(Datetime.moment())
    //     : currentDate.isAfter(yesterday);
    const eventWeeklyLimits = [2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12];
    const eventLimits = eventWeeklyLimits;
    const customStyles = {
      control: (base, state) => ({
        ...base,
        boxShadow: state.isFocused ? null : null,
        "&:hover": {
          borderColor: state.isFocused ? "hsl(0,0%,70%)" : "hsl(0,0%,70%)",
        },
      }),
    };
    let timeZoneValue;
    timezones["timezones"].map((zone) => {
      if (zone.value === time_zone) {
        timeZoneValue = zone.label;
      }
    });
    return (
      <Layout>
        <div className="main">
          {this.renderHeading()}
          <Container color={"#005c87"}>
            <div className="stepsNameHighlight">
              <StepsHeading stepCount={step} type="event" />
            </div>
            <div className="form">
              {/* <div className="heading">
                <div className="step">{step}</div>
                <div className="headingName">{this.props.t("When would you like to launch your event?")}</div>
              </div> */}
              <div className="formBody">

                {(companiesPermission||isAccountManager) && (
                  <StyledLabel isFont={"14px"} color={"#184A61"} margin="0px" symbolSize={"14px"} marginb={"12px"}>
                    {this.props.t("When would you like to launch your event?")}{<span>*</span>}
                  </StyledLabel>
                )}

                <React.Fragment>
                  <div className="radioButtonDiv" style={{marginTop:"20px"}}>
                    <span onClick={() => this.launchToggleButton(0)} style={{marginRight:"105px"}}>
                      <RadioButtonNew
                        id="global"
                        handler={this.launchToggleButton}
                        value={0}
                        isChecked={launch === 0}
                        label={t("Launch now")}
                        challengeCreate={true}
                      />
                    </span>
                    <span onClick={() => this.launchToggleButton(1)}>
                      <RadioButtonNew
                        id="company"
                        handler={this.launchToggleButton}
                        value={1}
                        isChecked={launch === 1}
                        label={t("Schedule for later")}
                        challengeCreate={true}
                      />
                    </span>
                  </div>
                  {/* <Border style={{background:'#EFEFEF',margin:'8px 0px'}}/> */}
                </React.Fragment>
            
               


                { launch ===0 || launch === 1 ? <>
                  <Border style={{background:'#EFEFEF',margin:'8px 0px'}}/>
                  <TitleContainer fullWidth margin="0 0 8px 0" style={{padding:"0px"}}>
                    <StyledLabel isFont={"14px"} color={"#184A61"} margin="0px" symbolSize={"14px"} marginb={"12px"}>
                      {this.props.t("What is your preferred time zone?")}
                      {<span>*</span>}
                    </StyledLabel>
                    <SearchDropDown
                      valueContainerP={"10px 16px"}
                      transform="none"
                      top="10px"
                      // transform={menuIsOpen ? "rotate(90deg)" : "0"}
                      pcolor={time_zone ? "#184A61" : "#BDBDBD"}
                      pfont={"Lato"}
                      // border={"1px solid #afcbd3"}
                      // borderColor={"#afcbd3"}
                      // background={"white"}
                      // color="#005c87"
                      style={{ height: "50px", width: '100%'}}
                    >
                      <Select
                        defaultValue={
                          time_zone ? timeZoneValue + (this.state.defaultTz === time_zone ? " (Default)" : "" ) : this.props.t("Select Timezone")
                        }
                        options={timezones["timezones"]}
                        onChange={(option) =>
                          this.onSelectCategory("time_zone", option.value)
                        }
                        classNamePrefix={"menu-item"}
                        styles={customStyles}
                        components={{ DropdownIndicator: this.DropdownIndicator }}
                        onMenuOpen={this.toggleMenu}
                        onMenuClose={this.toggleMenu}
                        placeholder={
                          time_zone ? timeZoneValue + (this.state.defaultTz === time_zone ? " (Default)" : "" ) : this.props.t("Select Timezone")
                        }
                      />
                    </SearchDropDown>
                  </TitleContainer>
                  <Border style={{background:'EFEFEF',margin:'8px 0px',display:"flex"}}/>
                  <div className="dateCard" style={{marginTop:"10px",gap:"8px"}}>
                    <DateCalendarWrapper>
                      <div className="date-title">Start date and time</div>
                      <DateCard  background={launch === 0} color={ launch === 0 || !date} onClick={ launch === 0 ? null :  ()=>this.hideShowCalendarPopup("date") }>
                        {date? dayjs(date).format("MM/DD/YYYY | hh:mm A") : "Select start date and time"}
                        {launch === 1 && CalendarBranding()}
                        {/* {EventsCalendarIcon(launch === 0 ? "#BDBDBD" : "#F37A65")} */}
                      </DateCard>
                    </DateCalendarWrapper> 
                    <DateCalendarWrapper>
                      <div className="date-title" style={{display:"flex",justifyContent:"space-between"}}>{showDateTimeInput != "date" ? "End date and time" : null}
                        {selectedOption === 0 ? <div className="radio" style={{width:"auto",display:"flex" }}>
                          <CustomRadioButton
                            marginR={"16px"}
                            isBorderColor={showDateTimeInput === "date" ? "1px solid #F37A65" : '1px solid #7C7C7C'}
                            onClick={() => !iseventUrl && this.changeDateTimeView(showDateTimeInput ? "" : "date")}
                            background={"#85c0ea"}
                            disabled={iseventUrl}
                          >
                            {" "}
                            {showDateTimeInput === "date" && <div></div>}
                          </CustomRadioButton>
                          {this.props.t("All day")}
                        </div>:null}
                      </div>
                      {showDateTimeInput != "date" ? <DateCard color={!endDate} onClick={()=>this.hideShowCalendarPopup("endDate")}>
                        {endDate? dayjs(endDate).format('MM/DD/YYYY | hh:mm A'): "Select end date and time"}
                        {CalendarBranding()}
                      </DateCard> : null}
                    </DateCalendarWrapper>
  
                  </div>
  
                  {this.state.showFrequency && <><Border style={{background:'#EFEFEF',margin:'8px 0px'}}/>
  
                    <StyledLabel isFont={"14px"} color={"#184A61"} margin="0px" symbolSize={"14px"}>
                      {this.props.t("Set frequency")}{<span>*</span>}
                    </StyledLabel>
                    <div className="radioButtonDiv">
                      <span
                        style={{marginRight:"90px" }}
                        // onClick={() =>
                        //   this.onChangeTimeZone("recurringEvent", "does not repeat")
                        // }
                      >
                        <RadioButtonNew
                          id="1"
                          // handler={() =>
                          //   this.onChangeTimeZone(
                          //     "recurringEvent",
                          //     "does not repeat"
                          //   )
                          // }
                          value={0}
                          isChecked={recurringEvent == "does not repeat"}
                          label={t("Do not repeat")}
                          challengeCreate={true}
                        />
                      </span>
                      {/* <span
                        onClick={() =>
                          this.onChangeTimeZone("recurringEvent", "weekly")
                        }
                      >
                        <RadioButtonNew
                          id="2"
                          handler={() =>
                            this.onChangeTimeZone("recurringEvent", "weekly")
                          }
                          value={1}
                          isChecked={recurringEvent == "weekly"}
                          label={t("Weekly")}
                          challengeCreate={true}
                          style={{ color: "#005c87" }}
                        />
                      </span> */}
                    </div></>
                  }
  
                  {recurringEvent !== recurringTypes[0] && (
                    <>
                      <Border style={{background:'#EFEFEF',margin:'8px 0px'}}/>
                      <StyledLabel isFont={"14px"} color={"#184A61"} margin="0px" symbolSize={"14px"} marginb={"0px"}>{this.props.t("Number of weeks")}</StyledLabel> 
                      <CommonDropdown
                        tileContainerStyle={{ width: "100%",padding:"0px",margin: "0" }}
                        createEventUI={true}
                        dropdownOpen={this.state.so}
                        dropdownStyle={{ top: "30px" }}
                        placeholder={this.props.t("Select number of weeks")}
                        labelText={""}
                        activityDropdownStyle={{ margin: "0 0 0px 0" }}
                        title={
                          eventLimitValue
                            ? `${eventLimitValue} ${"Weeks"}`
                            : this.props.t("Select Weeks")
                        }
                        id="dropdown-recurring"
                        onClick={() => this.setState({ so: !this.state.so })}
                        data={eventLimits}
                        onSelect={this.onSelectCategory}
                        onSelectParameter={["eventLimitValue", "item"]}
                        active={eventLimitValue}
                        itemValue={false}
                        valueString={"Weeks"}
                        valueIndex={1}
                        selectedClassCategory={eventLimitValue}
                        dropIcon={true}
                        labelMargin={"0px"}
                        fontSize={"14px"}
                      />
                    </>
                  )}

                </> : null}



                {/* <StyledLabelV2 justify style={{marginTop:"20px"}} isFont={"14px"} color={"#184A61"} symbolSize={"14px"} >
                  <div className="name" >
                    {this.props.t("Set Date and Time")}{<span>*</span>}
                  </div>
                  <div className="radio" style={{ width:"auto" }}>
                    <CustomRadioButtonNew
                      isChecked={showDateTimeInput === "date"}
                      onClick={() => this.changeDateTimeView(showDateTimeInput ? "" : "date")}
                      background={"#85c0ea"}
                    >
                      {" "}
                      {showDateTimeInput === "date" && <div></div>}
                    </CustomRadioButtonNew>
                    {this.props.t("All Day")}
                  </div>
                </StyledLabelV2> */}

                {/* {showDateTimeInput === "date" && (
                  <React.Fragment>
                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                      <MUICalendarWrapper>
                        <DateTimePicker
                          label="Select Start Date"
                          viewRenderers={{
                            hours: renderTimeViewClock,
                            minutes: renderTimeViewClock,
                            seconds: renderTimeViewClock,
                          }}
                          sx={{width:"416px",color:"#005C87",borderColor:"#005C87"}}
                          onChange={(value)=>{console.log("value",value?.$d); this.onChangeDate(value?.$d, "date")}}
                          value={date}
                          disablePast={true}
                          minDate={dayjs().add(1, 'day')}
                          // disabled={launch === 0}
                          slots={{openPickerIcon:CalendarIcon}}
                          
                        />
                      </MUICalendarWrapper>
                    </LocalizationProvider>
                  </React.Fragment>
                )} */}
                {/* <InputContainerV2 width={"47.5%"} onClick={() => {this.showDatePicker("date");}}>
                    <div
                      ref={(node) =>
                        openDateTimePicker === "date" &&
                        this.setDatePickerWrapper(node)
                      }
                    >
                      <StyledDateTime
                        open={openDateTimePicker === "date"}
                        inputProps={{
                          placeholder: moment().format("MM/DD/YYYY"),
                          readOnly: true,
                        }}
                        dateFormat="MM/DD/YYYY"
                        closeOnSelect={true}
                        closeOnTab={true}
                        timeFormat={false}
                        value={date}
                        onChange={(e) => this.changeDate(e, "date")}
                        isValidDate={valid}
                        bgColor={"white !important"}
                        border={"1px solid #afcbd3 !important"}
                        color={"#005c87 !important"}
                        
                      />
                      <DateIconContainer
                      >
                        <img src="/public/images/calendar.png" alt="calender" />
                      </DateIconContainer>
                    </div>

                  </InputContainerV2> */}


                  
               
                {/* {showDateTimeInput != "date" && (
                  <React.Fragment>
                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                      <MUICalendarWrapper>

                        <DateTimePicker
                          label="Select Start Date"
                          viewRenderers={{
                            hours: renderTimeViewClock,
                            minutes: renderTimeViewClock,
                            seconds: renderTimeViewClock,
                          }}
                          sx={{width:"416px",color:"#005C87",borderColor:"#005C87"}}
                          onChange={(value)=>{this.onChangeDate(value?.$d, "date")}}
                          value={date}
                          disabled={launch === 0}
                          maxDateTime={endDate}
                          slots={{openPickerIcon:CalendarIcon}}
                          disablePast={true}
                        />
                        {recurringEvent === recurringTypes[0] ? (<DateTimePicker
                          label="Select End Date"
                          viewRenderers={{
                            hours: renderTimeViewClock,
                            minutes: renderTimeViewClock,
                            seconds: renderTimeViewClock,
                          }}
                          sx={{width:"416px"}}
                          onChange={(value)=>{this.onChangeDate(value?.$d, "endDate")}}
                          value={endDate && endDate}
                          minDateTime={date}
                          slots={{openPickerIcon:CalendarIcon}}
                          disablePast={true}
                        />):(
                          <TimePicker
                            label="Select End Time"
                            viewRenderers={{
                              hours: renderTimeViewClock,
                              minutes: renderTimeViewClock,
                              seconds: renderTimeViewClock,
                            }}
                            sx={{width:"416px"}}
                            onChange={(value)=>{console.log("value",value?.$d); this.onChangeDate(value?.$d, "endDate")}}
                            slots={{openPickerIcon:CalendarIcon}}
                            disablePast={true}
                          />
                        )}
                      </MUICalendarWrapper>
                    </LocalizationProvider>
                  </React.Fragment>
                )} */}
                {/* <div className="dateCard">
   
                      <InputContainerV2 width={"47.5%"} onClick={() => this.showDatePicker("date")}>
                        <div
                          style={{ width: "100%" }}
                          ref={(node) =>
                            openDateTimePicker === "date" &&
                            this.setDatePickerWrapper(node)
                          }
                        >
                          <StyledDateTime
                            open={openDateTimePicker === "date"}
                            inputProps={{
                              placeholder: moment().format("MM/DD/YYYY"),
                              readOnly: true,
                            }}
                            dateFormat="MM/DD/YYYY"
                            closeOnSelect={true}
                            closeOnTab={true}
                            timeFormat={false}
                            value={date}
                            onChange={(e) => this.changeDate(e, "date")}
                            isValidDate={valid}
                            bgColor={"white !important"}
                            border={"1px solid #afcbd3 !important"}
                            color={"#005c87 !important"}                         
                          />
                          <DateIconContainer
                          >
                            <img src="/public/images/calendar.png" alt="calender" />
                          </DateIconContainer>
                        </div>
                      </InputContainerV2>
   
                      <div className="separate">-</div>
   
                      <InputContainerV2 width={"47.5%"} onClick={() => this.showDatePicker("time")} >
                        <div
                          style={{ width: "100%" }}
                          ref={(node) =>
                            openDateTimePicker === "time" &&
                            this.setDatePickerWrapper(node)
                          }
                        >
                          <StyledDateTime
                            open={openDateTimePicker === "time"}
                            inputProps={{
                              placeholder: moment().format("hh:mm a"),
                              readOnly: true,
                            }}
                            dateFormat={false}
                            closeOnTab={true}
                            value={time}
                            onChange={(e) => {this.changeDate(e, "time")}}
                            timeInput
                            bgColor={"white !important"}
                            border={"1px solid #afcbd3 !important"}
                            color={"#005c87 !important"}
                          />
                          <DateIconContainer
                          >
                            <StyledSvg
                              height="24px"
                              width="24px"
                              show="#005c87"
                              activeValue="#005c87"
                            >
                              <svg
                                width="24px"
                                height="24px"
                                viewBox="0 0 22 22"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                              >
                                <path
                                  d="M11 0C4.95 0 0 4.95 0 11C0 17.05 4.95 22 11 22C17.05 22 22 17.05 22 11C22 4.95 17.05 0 11 0ZM14.6667 12.8333H11C9.9 12.8333 9.16667 12.1 9.16667 11V5.5C9.16667 4.4 9.9 3.66667 11 3.66667C12.1 3.66667 12.8333 4.4 12.8333 5.5V9.16666H14.6667C15.7667 9.16666 16.5 9.9 16.5 11C16.5 12.1 15.7667 12.8333 14.6667 12.8333Z"
                                  fill="#005c87"
                                />
                              </svg>
                            </StyledSvg>
                          </DateIconContainer>
                        </div>
                      </InputContainerV2>
                    </div> */}
                 
                {/* {showDateTimeInput != "date" && (
                  <div className="dateCard">
                    {recurringEvent === recurringTypes[0] && (
                      <InputContainerV2 width={"47.5%"} onClick={() => this.showDatePicker("endDate")} >
                        <div
                          style={{ width: "100%" }}
                          ref={(node) =>
                            openDateTimePicker === "endDate" &&
                            this.setDatePickerWrapper(node)
                          }
                        >
                          <StyledDateTime
                            open={openDateTimePicker === "endDate"}
                            inputProps={{
                              placeholder: moment().format("MM/DD/YYYY"),
                              readOnly: true,
                            }}
                            dateFormat="MM/DD/YYYY"
                            closeOnSelect={true}
                            closeOnTab={true}
                            timeFormat={false}
                            value={endDate}
                            onChange={(e) => this.changeDate(e, "endDate")}
                            isValidDate={valid}
                            bgColor={"white !important"}
                            border={"1px solid #afcbd3 !important"}
                            color={"#005c87 !important"}
                          />
                          <DateIconContainer
                          >
                            <img src="/public/images/calendar.png" alt="calender" />
                          </DateIconContainer>
                        </div>
                      </InputContainerV2>
                    )}
                    {recurringEvent === recurringTypes[0] && (
                      <div className="separate">-</div>
                    )}

                    <InputContainerV2 width={"47.5%"} onClick={() => this.showDatePicker("endTime")} >
                      <div
                        style={{ width: "100%" }}
                        ref={(node) =>
                          openDateTimePicker === "endTime" &&
                          this.setDatePickerWrapper(node)
                        }
                      >
                        <StyledDateTime
                          open={openDateTimePicker === "endTime"}
                          inputProps={{
                            placeholder: moment().format("hh:mm a"),
                            readOnly: true,
                          }}
                          dateFormat={false}
                          closeOnTab={true}
                          value={endTime}
                          onChange={(e) => this.changeDate(e, "endTime")}
                          timeInput
                          bgColor={"white !important"}
                          border={"1px solid #afcbd3 !important"}
                          color={"#005c87 !important"}
                        />
                        <DateIconContainer
                        >
                          <StyledSvg
                            height="24px"
                            width="24px"
                            show="#005c87"
                            activeValue="#005c87"
                          >
                            <svg
                              width="24px"
                              height="24px"
                              viewBox="0 0 22 22"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <path
                                d="M11 0C4.95 0 0 4.95 0 11C0 17.05 4.95 22 11 22C17.05 22 22 17.05 22 11C22 4.95 17.05 0 11 0ZM14.6667 12.8333H11C9.9 12.8333 9.16667 12.1 9.16667 11V5.5C9.16667 4.4 9.9 3.66667 11 3.66667C12.1 3.66667 12.8333 4.4 12.8333 5.5V9.16666H14.6667C15.7667 9.16666 16.5 9.9 16.5 11C16.5 12.1 15.7667 12.8333 14.6667 12.8333Z"
                                fill="#005c87"
                              />
                            </svg>
                          </StyledSvg>
                        </DateIconContainer>
                      </div>
                    </InputContainerV2>
                  </div>
                )} */}

               
              </div>
            </div>
          </Container>
        </div>
        {showDatePopupModal&&<CustomDateTimePicker showModal={showDatePopupModal} onClose={this.hideCalendarPopup} date={datePopup==="date"? date: endDate} stateDateSelected={ datePopup==="date"?dayjs(new Date()):date} changeDate={this.onChangeDateValue} type={datePopup} />}
      </Layout>
    );
  };



  hideCalendarPopup= () =>{
    this.setState({
      showDatePopupModal: false,
      datePopup: ""
    })
  }
  
  onChangeDateValue = (date, stateName) => {
    this.setState({
      [stateName]: dayjs(date),
      showDatePopupModal: false
    },()=>{
      if(stateName === 'date'){
        this.setEmailerTemplateData();
      }

    });

  };


  stepFiveForm = () => {
    const{step,emailOption,/*recurringEvent,*/}=this.state;
    const {t} = this.props;
    let emailOptionKeys = Object.keys(emailOption);

    return(

      <Layout>
        <div className="main">
          {this.renderHeading()}
          <Container color={"#005c87"}>
            <div className="stepsNameHighlight">
              <StepsHeading stepCount={step} type="event" />
            </div>
            <div className="form">
              <div className="formBody">
                <StyledLabel isFont={"14px"} color={"#184A61"} margin="0px" symbolSize={"14px"} marginb={"12px"}>
                  {this.props.t("Email notifications: Select email option for this event")}
                </StyledLabel>
                <Locationwrapper
                  border
                  background="none"
                  marginTop="0"
                  padding="0"
                >
                  {emailOptionKeys.map((item, index) => (
                    <div className="checkBoxWidth" key={index}>
                      <span>
                        <CustomCheckBoxButton
                          isSelected={emailOption[item] === 1}
                          checked={emailOption[item] === 1}
                          // onClick={() =>
                          //   !(
                          //     index === 0 &&
                          //     recurringEvent !== recurringTypes[0]
                          //   ) && this.onChangeEmail(item)
                          // }
                          onClick={() => this.onChangeEmail(item)}
                        >
                          {emailOption[item] === 1 && (
                            <div>{RecognitionTickIcon()}</div>
                          )}
                        </CustomCheckBoxButton>
                        {t("Event")}
                        {item == "launch_event_email"
                          ? t(" Creation")
                          : item == "event_reminder_email"? t(" Reminder")
                            : t(" Completion")}
                      </span>
                    </div>
                  ))}
                </Locationwrapper>
                {emailOption.event_reminder_email ? this.emailerTemplate() : null}
              </div>
            </div>
          </Container>
        </div>
      </Layout>
    )
  }

  toggleTemplateSelection = (index) => {
    this.setState((prevState) => {
      const updatedTemplates = [...prevState.emailerTemplatesData];
      updatedTemplates[index].selected = !updatedTemplates[index]?.selected;
  
      return {
        emailerTemplatesData: updatedTemplates,
      };
    });
  };

  onChangeEmailerTemplate = (index, field, evt) => {
    // console.log(index, field, value);
    const newContent = evt.getData();
    this.setState((prevState) => {
      const updatedTemplates = [...prevState.emailerTemplatesData];
      updatedTemplates[index][field] = newContent;
  
      return {
        emailerTemplatesData: updatedTemplates,
      };
    });
  };

  emailerTemplate = ()=>{

    const{emailerTemplatesData, activeTemplateIndex, editTemplateIndex}=this.state;

    return(
      <>
        <Border style={{background:'#EFEFEF',margin:'0px'}}/>
        <StyledLabel margin="8px" marginb={"12px"} style={{float:'unset'}}>
          {this.props.t("Choose reminder")}
        </StyledLabel>
        {emailerTemplatesData.map((template,index)=>(
          <ReminderTemplate key={index} margin='0px 0px 12px 0px'>
            <div className="container">
              <div className="template-checkbox"> 
                <div className="checkBoxWidth">
                  <span>
                    <CustomCheckBoxButton
                      isSelected={template?.selected}
                      checked={template?.selected}
                      onClick={() => this.toggleTemplateSelection(index)}
                    >
                      {template?.selected && (
                        <div>{RecognitionTickIcon()}</div>
                      )}
                    </CustomCheckBoxButton>
                  </span>
                </div>
              </div>

              <div className="template-container">

                <div className="template-type" onClick={()=>this.setState({activeTemplateIndex:activeTemplateIndex === index ? null : index})}>
                  <div>{template?.template_type.toLowerCase().replace(/_/g, ' ')}</div>
                  <div>{DropIcon("#F37A65")}</div>
                </div>

                <div className="template-details">
                  {editTemplateIndex === index ? <>
                    <InputContainer  
                      // isColorError={charCount > 3000 ? true : false}
                    >
                      <StyledLabel margin="0px" symbolSize={"14px"} style={{fontWeight:'700'}}>{this.props.t("Subject")}</StyledLabel>
                      <EditorContainer>
                        <Editor
                          content={template?.template_subject}
                          // disabled={isCustomizedEvent}
                          onChange={(editor) => this.onChangeEmailerTemplate(index, 'template_subject', editor)}
                          minHeight={'auto'}
                          backgroundColor="#F8F8F8"
                        />
                      </EditorContainer>
                      {/* <div className="char-count">{charCount}/3000 | C</div> */}
                    </InputContainer>

                    <Border style={{background:'#EFEFEF',margin:'10px 0px'}}/>

                    <InputContainer>
                      <StyledLabel margin="0px" symbolSize={"14px"} style={{fontWeight:'700'}}>{this.props.t("Email Body")}</StyledLabel>
                      <EditorContainer>
                        <Editor
                          content={template?.template_text}
                          onChange={(editor) => this.onChangeEmailerTemplate(index, 'template_text', editor)}
                          minHeight={'auto'}
                          backgroundColor="#F8F8F8"
                        />
                      </EditorContainer>
                    </InputContainer>

                    <Border style={{background:'#EFEFEF',margin:'10px 0px'}}/>

                    <InputContainer>
                      <StyledLabel margin="0px" symbolSize={"14px"} style={{fontWeight:'700'}}>{this.props.t("Call to Action")}</StyledLabel>
                      <EditorContainer>
                        <Editor
                          content={template?.template_cta_text}
                          onChange={(editor) => this.onChangeEmailerTemplate(index, 'template_cta_text', editor)}
                          minHeight={'auto'}
                          backgroundColor="#F8F8F8"
                          color='#F37A65'
                        />
                      </EditorContainer>
                    </InputContainer>

                    <Border style={{background:'#EFEFEF',margin:'10px 0px'}}/>

                    <InputContainer>
                      <StyledLabel margin="0px" symbolSize={"14px"} style={{fontWeight:'700'}}>{this.props.t("Email Sign off")}</StyledLabel>
                      <EditorContainer>
                        <Editor
                          content={template?.template_signature_text}
                          onChange={(editor) => this.onChangeEmailerTemplate(index, 'template_signature_text', editor)}
                          minHeight={'auto'}
                          backgroundColor="#F8F8F8"
                        />
                      </EditorContainer>
                    </InputContainer>
                    <Border style={{background:'#EFEFEF',margin:'10px 0px'}}/>
                    <div className="edit-copy"><CommonButtonBorder onClick={()=>this.setState({editTemplateIndex:editTemplateIndex === index ? null : index})}>{editTemplateIndex === index ?'Save Copy' :'Edit Copy'}</CommonButtonBorder></div>
                  </> : (<>
                    <div><span className="subject">Subject:</span> {parse(template?.template_subject)}</div>
                    {activeTemplateIndex === index ? <> <Border style={{background:'#EFEFEF',margin:'10px 0px'}}/>
                      <div>{parse(template?.template_text)}</div>
                      <div className="cta-text">{parse(template?.template_cta_text)}</div>
                      <div className="sign-off-text">{parse(template?.template_signature_text)}</div>
                      <Border style={{background:'#EFEFEF',margin:'10px 0px'}}/>
                      <div className="edit-copy"><CommonButtonBorder onClick={()=>this.setState({editTemplateIndex:editTemplateIndex === index ? null : index})}>{editTemplateIndex === index ?'Save Copy' :'Edit Copy'}</CommonButtonBorder></div></> : null} 
                  </>)}
                </div>
              </div>

            </div>
            
          </ReminderTemplate>
        ))}
      </>
    )
  }

  render() {
    const {
      companiesPermission,
      locationPermission,
      step,
      city_location,
      companies,
      // time_zone,
      // date,
      title,
      imgSrc,
      description,
      limitUser,
      location,
      eventLink,
      addLimitCheckbox,
      buttonStatus,
      selectedOption,
      iseventUrl,
      isEmployee,
      isDependent,
      isSpouse,
      usersToInvite,
      departments,
      teams,
      eventPointValue,
      eventThemePointValue,
      participantingPointValue,
      charCount,
      coachId,
      emailOption,
      emailerTemplatesData,
      loading,
      isCustomizedEvent,
      isCelebrationEvent
    } = this.state;


    const { isLoading, allCompanies, userCompany, role, locationDetails, companyDetails, isAccountManager } =
      this.props;
    if (
      (companiesPermission && !allCompanies) ||
      (locationPermission && !userCompany) ||
      isLoading || loading
    ) {
      return <Waiting />;
    }

    const thirdStepDisabled= ( !companies.length > 0 && (role === "ADMIN"||isAccountManager)) ||
        ((role !== "ADMIN"&&!isAccountManager) &&(!city_location.length > 0 &&!_.isEmpty(locationDetails) && usersToInvite === 2) || ((role !== "ADMIN"&&!isAccountManager) && !isEmployee && !isDependent&& !isSpouse && _.isEmpty(locationDetails) && companyDetails && companyDetails['spouse_or_dependent']) || companies.length === 0 || (usersToInvite === 2 && !city_location.length > 0) || (usersToInvite === 1 && !departments.length > 0) || (usersToInvite === 3 && !teams.length > 0));
    const isAnyTemplateSelected = emailerTemplatesData.some((template) => template.selected);

    return (
      <React.Fragment>
        {step === 1
          ? this.stepOneForm()
          : step === 2 
            ? (isCustomizedEvent  || isCelebrationEvent ? this.stepTwoThemeEventForm() : this.stepTwoForm())
            : step === 3
              ? this.stepThreeForm():
              step === 4
                ? this.stepFourForm():
                this.stepFiveForm() }
        {step === 1 ? (
          <ButtonContainer>
            <Main>
              <CommonButtonPopup height="48px" width="200px" margin="auto 0 auto auto" disabled={!title||!imgSrc|| !description || (charCount > 3000)} onClick={!title||!imgSrc|| !description || (charCount > 3000)?null: () => this.updateStep(2)}>
               Next
                {/* {!title||!imgSrc|| !description || (charCount > 3000) ? AdminRightArrowIcon("#989898") : AdminRightArrowIcon()} */}
              </CommonButtonPopup>
            </Main>
          </ButtonContainer>
        ) : step === 2 ? (
          ( isCustomizedEvent || isCelebrationEvent) ? 
            (<ButtonContainer>
              <div className="wrapper">
                <CommonButtonBorder width="200px" height="48px"
                  onClick={() => this.updateStep(1)}
                  margin="auto auto auto 0px">
                   Back
                </CommonButtonBorder>
                <CommonButtonPopup height="48px" width="200px" margin="auto 0 auto auto"   disabled={(!eventThemePointValue && eventThemePointValue != 0) || (!participantingPointValue && participantingPointValue != 0)}    onClick={(!eventThemePointValue && eventThemePointValue != 0) || (!participantingPointValue && participantingPointValue != 0) ? null: () => this.updateStep(3)}>
                 Next
                </CommonButtonPopup>
              </div>
            </ButtonContainer>):
            (<ButtonContainer>
              <div className="wrapper">
                <CommonButtonBorder width="200px" height="48px"
                  onClick={() => this.updateStep(1)}
                  margin="auto auto auto 0px">
                  {/* {AdminLeftArrowIcon("#F37A65")} */}
                   Back
                </CommonButtonBorder>
                <CommonButtonPopup height="48px" width="200px" margin="auto 0 auto auto"   disabled={ (addLimitCheckbox && (!limitUser || parseInt(limitUser, 10) === 0)) ||  (coachId !== 0 && !coachId )|| (!location&&!eventLink) || (selectedOption === 1 && !iseventUrl || (!eventPointValue && eventPointValue != 0) || (!this.state.selectFlayer && !this.state.flayerName) )} onClick={  (addLimitCheckbox && (!limitUser || parseInt(limitUser, 10) === 0)) || (coachId !== 0 && !coachId ) ||(!location&&!eventLink) || (selectedOption === 1 && !iseventUrl || (!eventPointValue && eventPointValue != 0) || (!this.state.selectFlayer && !this.state.flayerName) ) ?null: () => this.updateStep(3)}>
                Next
                  {/* { (addLimitCheckbox && (!limitUser || parseInt(limitUser, 10) === 0))  || (coachId !== 0 && !coachId ) || (!location&&!eventLink) || (selectedOption === 1 && !iseventUrl || (!eventPointValue && eventPointValue != 0) || (!this.state.selectFlayer && !this.state.flayerName) ) ? AdminRightArrowIcon("#989898") : AdminRightArrowIcon()} */}
                </CommonButtonPopup>
              </div>
            </ButtonContainer>)
        ) : step === 3 ? (
          <ButtonContainer>
            <div className="wrapper">
              <CommonButtonBorder width="200px" height="48px"
                onClick={() => this.updateStep(2)}
                margin="auto auto auto 0px">
                {/* {AdminLeftArrowIcon("#F37A65")} */}
                 Back
              </CommonButtonBorder>
              <CommonButtonPopup height="48px" width="200px" margin="auto 0 auto auto"   disabled={thirdStepDisabled}
                onClick={thirdStepDisabled ? null :() => this.updateStep(4)}> Next
                {/* {AdminRightArrowIcon(thirdStepDisabled ? "#989898" : "#F37A65")} */}
              </CommonButtonPopup>
            </div>
          </ButtonContainer>
        ) : (
          step === 4 ? (
            <ButtonContainer>
              <div className="wrapper">
                <CommonButtonBorder width="200px" height="48px"
                  onClick={() => this.nextStep(3)}
                  margin="auto auto auto 0px">
                  {/* {AdminLeftArrowIcon("#F37A65")} */}
                   Back
                </CommonButtonBorder>
                <CommonButtonPopup height="48px" width="200px" margin="auto 0 auto auto" 
                  disabled={ !this.state.endDate}
                  onClick={ !this.state.endDate ? null: () =>{this.updateStep(5);!emailerTemplatesData.length && this.setEmailerTemplateData()}}>
                  Next
                  {/* { !this.state.endDate  ? AdminRightArrowIcon("#989898") : AdminRightArrowIcon()} */}
                </CommonButtonPopup>
              </div>
            </ButtonContainer>
          ) : (
            step === 5 && (
              <ButtonContainer>
                <div className="wrapper">
                  <CommonButtonBorder width="200px" height="48px"
                    onClick={() => this.nextStep(4)}
                    margin="auto auto auto 0px">
                    {/* {AdminLeftArrowIcon("#F37A65")} */}
                     Back
                  </CommonButtonBorder>
                  {/* <CommonButton
                    btnType={"squareIcon"}
                    disabled={buttonStatus}
                    styles={{color:"#007AB1", marginAuto:'auto'}}
                    onClick={!buttonStatus? () => this.saveEvent():null}
                    title={this.props.t("Launch Event")}
                    nextIcon={LaunchEventIcon()}
                  /> */}

                  <CommonButtonPopup height="48px" width="200px" margin="auto 0 auto auto" 
                    disabled={ buttonStatus || (emailOption.event_reminder_email && !isAnyTemplateSelected)}
                    onClick={buttonStatus ? null: () => this.saveEvent()}>
                     Launch Event
                  </CommonButtonPopup>
                </div>
              </ButtonContainer>
            )
          )
        )}
      </React.Fragment>
    );
  }
}

CreateEvent.propTypes = {
  createEvent: PropTypes.func.isRequired,
  getPlacesAction: PropTypes.func.isRequired,
  places: PropTypes.array,
  isLoading: PropTypes.bool,
  history: PropTypes.object.isRequired,
  role: PropTypes.string.isRequired,
  fetchAllCompanies: PropTypes.func.isRequired,
  allCompanies: PropTypes.array,
  fetchCompanyForUser: PropTypes.func.isRequired,
  userCompany: PropTypes.object,
  locationDetails: PropTypes.array,
  allowChallengeEventForSpouseDependent: PropTypes.func,
  companyDetails: PropTypes.object,
  userPermissions: PropTypes.array,
  t: PropTypes.func,
  getCompanyLocation: PropTypes.func,
  getCompanyDepartment:PropTypes.func,
  departmentDetails:PropTypes.array,
  createEventError:PropTypes.string,
  isAccountManager: PropTypes.bool
};

const mapStateToProps = (state) => ({
  allCompanies: state.challenges.allCompanies,
  userCompany: state.profileData.userCompany,
  locationDetails: state.register.locationDetails,
  companyDetails: state.profileData.companyDetails,
  departmentDetails: state.register.departmentDetails,
  createEventError:state.events.createEventError
});

const mapDispatchToProps = (dispatch) => ({
  fetchAllCompanies: () => dispatch(getAllCompanies()),
  fetchCompanyForUser: () => dispatch(getUserCompanyDetails()),
  allowChallengeEventForSpouseDependent: () =>dispatch(allowChallengeEventForSpouseDependent),
  getCompanyLocation: (id) => dispatch(getCompanyLocation(id)),
  getCompanyDepartment: (id) => dispatch(getCompanyDepartment(id))
});

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(withTranslation()(CreateEvent)));